export const DICOM_TAGS: Record<string, string> = {
  '00080001': 'Length to End',
  '00080005': 'Specific Character Set',
  '00080006': 'Language Code Sequence',
  '00080008': 'Image Type',
  '00080010': 'Recognition Code',
  '00080012': 'Instance Creation Date',
  '00080013': 'Instance Creation Time',
  '00080014': 'Instance Creator UID',
  '00080015': 'Instance Coercion DateTime',
  '00080016': 'SOP Class UID',
  '00080018': 'SOP Instance UID',
  '0008001A': 'Related General SOP Class UID',
  '0008001B': 'Original Specialized SOP Class UID',
  '00080020': 'Study Date',
  '00080021': 'Series Date',
  '00080022': 'Acquisition Date',
  '00080023': 'Content Date',
  '00080024': 'Overlay Date',
  '00080025': 'Curve Date',
  '0008002A': 'Acquisition DateTime',
  '00080030': 'Study Time',
  '00080031': 'Series Time',
  '00080032': 'Acquisition Time',
  '00080033': 'Content Time',
  '00080034': 'Overlay Time',
  '00080035': 'Curve Time',
  '00080040': 'Data Set Type',
  '00080041': 'Data Set Subtype',
  '00080042': 'Nuclear Medicine Series Type',
  '00080050': 'Accession Number',
  '00080051': 'Issuer of Accession Number Sequence',
  '00080052': 'Query/Retrieve Level',
  '00080053': 'Query/Retrieve View',
  '00080054': 'Retrieve AE Title',
  '00080056': 'Instance Availability',
  '00080058': 'Failed SOP Instance UID List',
  '00080060': 'Modality',
  '00080061': 'Modalities in Study',
  '00080062': 'SOP Classes in Study',
  '00080064': 'Conversion Type',
  '00080068': 'Presentation Intent Type',
  '00080070': 'Manufacturer',
  '00080080': 'Institution Name',
  '00080081': 'Institution Address',
  '00080082': 'Institution Code Sequence',
  '00080090': 'Referring Physicians Name',
  '00080092': 'Referring Physicians Address',
  '00080094': 'Referring Physicians Telephone Numbers',
  '00080096': 'Referring Physician Identification Sequence',
  '00080100': 'Code Value',
  '00080101': 'Extended Code Value',
  '00080102': 'Coding Scheme Designator',
  '00080103': 'Coding Scheme Version',
  '00080104': 'Code Meaning',
  '00080105': 'Mapping Resource',
  '00080106': 'Context Group Version',
  '00080107': 'Context Group Local Version',
  '00080108': 'Extended Code Meaning',
  '0008010B': 'Context Group Extension Flag',
  '0008010C': 'Coding Scheme UID',
  '0008010D': 'Context Group Extension Creator UID',
  '0008010F': 'Context Identifier',
  '00080110': 'Coding Scheme Identification Sequence',
  '00080112': 'Coding Scheme Registry',
  '00080114': 'Coding Scheme External ID',
  '00080115': 'Coding Scheme Name',
  '00080116': 'Coding Scheme Responsible Organization',
  '00080117': 'Context UID',
  '00080201': 'Timezone Offset From UTC',
  '00081000': 'Network ID',
  '00081010': 'Station Name',
  '00081030': 'Study Description',
  '00081032': 'Procedure Code Sequence',
  '0008103E': 'Series Description',
  '0008103F': 'Series Description Code Sequence',
  '00081040': 'Institutional Department Name',
  '00081048': 'Physician(s) of Record',
  '00081049': 'Physician(s) of Record Identification Sequence',
  '00081050': 'Performing Physicians Name',
  '00081052': 'Performing Physician Identification Sequence',
  '00081060': 'Name of Physician(s) Reading Study',
  '00081062': 'Physician(s) Reading Study Identification Sequence',
  '00081070': 'Operators Name',
  '00081072': 'Operator Identification Sequence',
  '00081080': 'Admitting Diagnoses Description',
  '00081084': 'Admitting Diagnoses Code Sequence',
  '00081090': 'Manufacturers Model Name',
  '00081100': 'Referenced Results Sequence',
  '00081110': 'Referenced Study Sequence',
  '00081111': 'Referenced Performed Procedure Step Sequence',
  '00081115': 'Referenced Series Sequence',
  '00081120': 'Referenced Patient Sequence',
  '00081125': 'Referenced Visit Sequence',
  '00081130': 'Referenced Overlay Sequence',
  '00081134': 'Referenced Stereometric Instance Sequence',
  '0008113A': 'Referenced Waveform Sequence',
  '00081140': 'Referenced Image Sequence',
  '00081145': 'Referenced Curve Sequence',
  '0008114A': 'Referenced Instance Sequence',
  '0008114B': 'Referenced Real World Value Mapping Instance Sequence',
  '00081150': 'Referenced SOP Class UID',
  '00081155': 'Referenced SOP Instance UID',
  '0008115A': 'SOP Classes Supported',
  '00081160': 'Referenced Frame Number',
  '00081161': 'Simple Frame List',
  '00081162': 'Calculated Frame List',
  '00081163': 'Time​Range',
  '00081164': 'Frame Extraction Sequence',
  '00081167': 'Multi-frame Source SOP Instance UID',
  '00081190': 'Retrieve URL',
  '00081195': 'Transaction UID',
  '00081196': 'Warning Reason',
  '00081197': 'Failure Reason',
  '00081198': 'Failed SOP Sequence',
  '00081199': 'Referenced SOP Sequence',
  '00081200': 'Studies Containing Other Referenced Instances Sequence',
  '00081250': 'Related Series Sequence',
  '00082110': 'Lossy Image Compression (Retired)',
  '00082111': 'Derivation Description',
  '00082112': 'Source Image Sequence',
  '00082120': 'Stage Name',
  '00082122': 'Stage Number',
  '00082124': 'Number of Stages',
  '00082127': 'View Name',
  '00082128': 'View Number',
  '00082129': 'Number of Event Timers',
  '0008212A': 'Number of Views in Stage',
  '00082130': 'Event Elapsed Time(s)',
  '00082132': 'Event Timer Name(s)',
  '00082133': 'Event Timer Sequence',
  '00082134': 'Event Time Offset',
  '00082135': 'Event Code Sequence',
  '00082142': 'Start Trim',
  '00082143': 'Stop Trim',
  '00082144': 'Recommended Display Frame Rate',
  '00082200': 'Transducer Position',
  '00082204': 'Transducer Orientation',
  '00082208': 'Anatomic Structure',
  '00082218': 'Anatomic Region Sequence',
  '00082220': 'Anatomic Region Modifier Sequence',
  '00082228': 'Primary Anatomic Structure Sequence',
  '00082229': 'Anatomic Structure, Space or Region Sequence',
  '00082230': 'Primary Anatomic Structure Modifier Sequence',
  '00082240': 'Transducer Position Sequence',
  '00082242': 'Transducer Position Modifier Sequence',
  '00082244': 'Transducer Orientation Sequence',
  '00082246': 'Transducer Orientation Modifier Sequence',
  '00082251': 'Anatomic Structure Space Or Region Code Sequence (Trial)',
  '00082253': 'Anatomic Portal Of Entrance Code Sequence (Trial)',
  '00082255': 'Anatomic Approach Direction Code Sequence (Trial)',
  '00082256': 'Anatomic Perspective Description (Trial)',
  '00082257': 'Anatomic Perspective Code Sequence (Trial)',
  '00082258': 'Anatomic Location Of Examining Instrument Description (Trial)',
  '00082259': 'Anatomic Location Of Examining Instrument Code Sequence (Trial)',
  '0008225A': 'Anatomic Structure Space Or Region Modifier Code Sequence (Trial)',
  '0008225C': 'On​Axis Background Anatomic Structure Code Sequence (Trial)',
  '00083001': 'Alternate Representation Sequence',
  '00083010': 'Irradiation Event UID',
  '00084000': 'Identifying Comments',
  '00089007': 'Frame Type',
  '00089092': 'Referenced Image Evidence Sequence',
  '00089121': 'Referenced Raw Data Sequence',
  '00089123': 'Creator-Version UID',
  '00089124': 'Derivation Image Sequence',
  '00089154': 'Source Image Evidence Sequence',
  '00089205': 'Pixel Presentation',
  '00089206': 'Volumetric Properties',
  '00089207': 'Volume Based Calculation Technique',
  '00089208': 'Complex Image Component',
  '00089209': 'Acquisition Contrast',
  '00089215': 'Derivation Code Sequence',
  '00089237': 'Referenced Presentation State Sequence',
  '00089410': 'Referenced Other Plane Sequence',
  '00089458': 'Frame Display Sequence',
  '00089459': 'Recommended Display Frame Rate in Float',
  '00089460': 'Skip Frame Range Flag',
  '00100010': 'Patients Name',
  '00100020': 'Patient ID',
  '00100021': 'Issuer of Patient ID',
  '00100022': 'Type of Patient ID',
  '00100024': 'Issuer of Patient ID Qualifiers Sequence',
  '00100030': 'Patients Birth Date',
  '00100032': 'Patients Birth Time',
  '00100040': 'Patients Sex',
  '00100050': 'Patients Insurance Plan Code Sequence',
  '00100101': 'Patients Primary Language Code Sequence',
  '00100102': 'Patients Primary Language Modifier Code Sequence',
  '00100200': 'Quality Control Subject',
  '00100201': 'Quality Control Subject Type Code Sequence',
  '00101000': 'Other Patient I​Ds',
  '00101001': 'Other Patient Names',
  '00101002': 'Other Patient I​Ds Sequence',
  '00101005': 'Patients Birth Name',
  '00101010': 'Patients Age',
  '00101020': 'Patients Size',
  '00101021': 'Patients Size Code Sequence',
  '00101030': 'Patients Weight',
  '00101040': 'Patients Address',
  '00101050': 'Insurance Plan Identification',
  '00101060': 'Patients Mothers Birth Name',
  '00101080': 'Military Rank',
  '00101081': 'Branch of Service',
  '00101090': 'Medical Record Locator',
  '00102000': 'Medical Alerts',
  '00102110': 'Allergies',
  '00102150': 'Country of Residence',
  '00102152': 'Region of Residence',
  '00102154': 'Patients Telephone Numbers',
  '00102160': 'Ethnic Group',
  '00102180': 'Occupation',
  '001021A0': 'Smoking Status',
  '001021B0': 'Additional Patient History',
  '001021C0': 'Pregnancy Status',
  '001021D0': 'Last Menstrual Date',
  '001021F0': 'Patients Religious Preference',
  '00102201': 'Patient Species Description',
  '00102202': 'Patient Species Code Sequence',
  '00102203': 'Patients Sex Neutered',
  '00102210': 'Anatomical Orientation Type',
  '00102292': 'Patient Breed Description',
  '00102293': 'Patient Breed Code Sequence',
  '00102294': 'Breed Registration Sequence',
  '00102295': 'Breed Registration Number',
  '00102296': 'Breed Registry Code Sequence',
  '00102297': 'Responsible Person',
  '00102298': 'Responsible Person Role',
  '00102299': 'Responsible Organization',
  '00104000': 'Patient Comments',
  '00109431': 'Examined Body Thickness',
  '00120010': 'Clinical Trial Sponsor Name',
  '00120020': 'Clinical Trial Protocol ID',
  '00120021': 'Clinical Trial Protocol Name',
  '00120030': 'Clinical Trial Site ID',
  '00120031': 'Clinical Trial Site Name',
  '00120040': 'Clinical Trial Subject ID',
  '00120042': 'Clinical Trial Subject Reading ID',
  '00120050': 'Clinical Trial Time Point ID',
  '00120051': 'Clinical Trial Time Point Description',
  '00120060': 'Clinical Trial Coordinating Center Name',
  '00120062': 'Patient Identity Removed',
  '00120063': 'De-identification Method',
  '00120064': 'De-identification Method Code Sequence',
  '00120071': 'Clinical Trial Series ID',
  '00120072': 'Clinical Trial Series Description',
  '00120081': 'Clinical Trial Protocol Ethics Committee Name',
  '00120082': 'Clinical Trial Protocol Ethics Committee Approval Number',
  '00120083': 'Consent for Clinical Trial Use Sequence',
  '00120084': 'Distribution Type',
  '00120085': 'Consent for Distribution Flag',
  '00140023': 'CAD File Format',
  '00140024': 'Component Reference System',
  '00140025': 'Component Manufacturing Procedure',
  '00140028': 'Component Manufacturer',
  '00140030': 'Material Thickness',
  '00140032': 'Material Pipe Diameter',
  '00140034': 'Material Isolation Diameter',
  '00140042': 'Material Grade',
  '00140044': 'Material Properties Description',
  '00140045': 'Material Properties File Format (Retired)',
  '00140046': 'Material Notes',
  '00140050': 'Component Shape',
  '00140052': 'Curvature Type',
  '00140054': 'Outer Diameter',
  '00140056': 'Inner Diameter',
  '00141010': 'Actual Environmental Conditions',
  '00141020': 'Expiry Date',
  '00141040': 'Environmental Conditions',
  '00142002': 'Evaluator Sequence',
  '00142004': 'Evaluator Number',
  '00142006': 'Evaluator Name',
  '00142008': 'Evaluation Attempt',
  '00142012': 'Indication Sequence',
  '00142014': 'Indication Number',
  '00142016': 'Indication Label',
  '00142018': 'Indication Description',
  '0014201A': 'Indication Type',
  '0014201C': 'Indication Disposition',
  '0014201E': 'Indication ROI Sequence',
  '00142030': 'Indication Physical Property Sequence',
  '00142032': 'Property Label',
  '00142202': 'Coordinate System Number of Axes',
  '00142204': 'Coordinate System Axes Sequence',
  '00142206': 'Coordinate System Axis Description',
  '00142208': 'Coordinate System Data Set Mapping',
  '0014220A': 'Coordinate System Axis Number',
  '0014220C': 'Coordinate System Axis Type',
  '0014220E': 'Coordinate System Axis Units',
  '00142210': 'Coordinate System Axis Values',
  '00142220': 'Coordinate System Transform Sequence',
  '00142222': 'Transform Description',
  '00142224': 'Transform Number of Axes',
  '00142226': 'Transform Order of Axes',
  '00142228': 'Transformed Axis Units',
  '0014222A': 'Coordinate System Transform Rotation and Scale Matrix',
  '0014222C': 'Coordinate System Transform Translation Matrix',
  '00143011': 'Internal Detector Frame Time',
  '00143012': 'Number of Frames Integrated',
  '00143020': 'Detector Temperature Sequence',
  '00143022': 'Sensor Name',
  '00143024': 'Horizontal Offset of Sensor',
  '00143026': 'Vertical Offset of Sensor',
  '00143028': 'Sensor Temperature',
  '00143040': 'Dark Current Sequence',
  '00143050': 'Dark Current Counts',
  '00143060': 'Gain Correction Reference Sequence',
  '00143070': 'Air Counts',
  '00143071': 'KV Used in Gain Calibration',
  '00143072': 'MA Used in Gain Calibration',
  '00143073': 'Number of Frames Used for Integration',
  '00143074': 'Filter Material Used in Gain Calibration',
  '00143075': 'Filter Thickness Used in Gain Calibration',
  '00143076': 'Date of Gain Calibration',
  '00143077': 'Time of Gain Calibration',
  '00143080': 'Bad Pixel Image',
  '00143099': 'Calibration Notes',
  '00144002': 'Pulser Equipment Sequence',
  '00144004': 'Pulser Type',
  '00144006': 'Pulser Notes',
  '00144008': 'Receiver Equipment Sequence',
  '0014400A': 'Amplifier Type',
  '0014400C': 'Receiver Notes',
  '0014400E': 'Pre-Amplifier Equipment Sequence',
  '0014400F': 'Pre-Amplifier Notes',
  '00144010': 'Transmit Transducer Sequence',
  '00144011': 'Receive Transducer Sequence',
  '00144012': 'Number of Elements',
  '00144013': 'Element Shape',
  '00144014': 'Element Dimension A',
  '00144015': 'Element Dimension B',
  '00144016': 'Element Pitch A',
  '00144017': 'Measured Beam Dimension A',
  '00144018': 'Measured Beam Dimension B',
  '00144019': 'Location of Measured Beam Diameter',
  '0014401A': 'Nominal Frequency',
  '0014401B': 'Measured Center Frequency',
  '0014401C': 'Measured Bandwidth',
  '0014401D': 'Element Pitch B',
  '00144020': 'Pulser Settings Sequence',
  '00144022': 'Pulse Width',
  '00144024': 'Excitation Frequency',
  '00144026': 'Modulation Type',
  '00144028': 'Damping',
  '00144030': 'Receiver Settings Sequence',
  '00144031': 'Acquired Soundpath Length',
  '00144032': 'Acquisition Compression Type',
  '00144033': 'Acquisition Sample Size',
  '00144034': 'Rectifier Smoothing',
  '00144035': 'DAC Sequence',
  '00144036': 'DAC Type',
  '00144038': 'DAC Gain Points',
  '0014403A': 'DAC Time Points',
  '0014403C': 'DAC Amplitude',
  '00144040': 'Pre-Amplifier Settings Sequence',
  '00144050': 'Transmit Transducer Settings Sequence',
  '00144051': 'Receive Transducer Settings Sequence',
  '00144052': 'Incident Angle',
  '00144054': 'Coupling Technique',
  '00144056': 'Coupling Medium',
  '00144057': 'Coupling Velocity',
  '00144058': 'Probe Center Location X',
  '00144059': 'Probe Center Location Z',
  '0014405A': 'Sound Path Length',
  '0014405C': 'Delay Law Identifier',
  '00144060': 'Gate Settings Sequence',
  '00144062': 'Gate Threshold',
  '00144064': 'Velocity of Sound',
  '00144070': 'Calibration Settings Sequence',
  '00144072': 'Calibration Procedure',
  '00144074': 'Procedure Version',
  '00144076': 'Procedure Creation Date',
  '00144078': 'Procedure Expiration Date',
  '0014407A': 'Procedure Last Modified Date',
  '0014407C': 'Calibration Time',
  '0014407E': 'Calibration Date',
  '00144080': 'Probe Drive Equipment Sequence',
  '00144081': 'Drive Type',
  '00144082': 'Probe Drive Notes',
  '00144083': 'Drive Probe Sequence',
  '00144084': 'Probe Inductance',
  '00144085': 'Probe Resistance',
  '00144086': 'Receive Probe Sequence',
  '00144087': 'Probe Drive Settings Sequence',
  '00144088': 'Bridge Resistors',
  '00144089': 'Probe Orientation Angle',
  '0014408B': 'User Selected Gain Y',
  '0014408C': 'User Selected Phase',
  '0014408D': 'User Selected Offset X',
  '0014408E': 'User Selected Offset Y',
  '00144091': 'Channel Settings Sequence',
  '00144092': 'Channel Threshold',
  '0014409A': 'Scanner Settings Sequence',
  '0014409B': 'Scan Procedure',
  '0014409C': 'Translation Rate X',
  '0014409D': 'Translation Rate Y',
  '0014409F': 'Channel Overlap',
  '001440A0': 'Image Quality Indicator Type',
  '001440A1': 'Image Quality Indicator Material',
  '001440A2': 'Image Quality Indicator Size',
  '00145002': 'LINAC Energy',
  '00145004': 'LINAC Output',
  '00180010': 'Contrast/Bolus Agent',
  '00180012': 'Contrast/Bolus Agent Sequence',
  '00180014': 'Contrast/Bolus Administration Route Sequence',
  '00180015': 'Body Part Examined',
  '00180020': 'Scanning Sequence',
  '00180021': 'Sequence Variant',
  '00180022': 'Scan Options',
  '00180023': 'MR Acquisition Type',
  '00180024': 'Sequence Name',
  '00180025': 'Angio Flag',
  '00180026': 'Intervention Drug Information Sequence',
  '00180027': 'Intervention Drug Stop Time',
  '00180028': 'Intervention Drug Dose',
  '00180029': 'Intervention Drug Code Sequence',
  '0018002A': 'Additional Drug Sequence',
  '00180030': 'Radionuclide',
  '00180031': 'Radio​pharmaceutical',
  '00180032': 'Energy Window Centerline',
  '00180033': 'Energy Window Total Width',
  '00180034': 'Intervention Drug Name',
  '00180035': 'Intervention Drug Start Time',
  '00180036': 'Intervention Sequence',
  '00180037': 'Therapy Type',
  '00180038': 'Intervention Status',
  '00180039': 'Therapy Description',
  '0018003A': 'Intervention Description',
  '00180040': 'Cine Rate',
  '00180042': 'Initial Cine Run State',
  '00180050': 'Slice Thickness',
  '00180060': 'KVP',
  '00180070': 'Counts Accumulated',
  '00180071': 'Acquisition Termination Condition',
  '00180072': 'Effective Duration',
  '00180073': 'Acquisition Start Condition',
  '00180074': 'Acquisition Start Condition Data',
  '00180075': 'Acquisition Termination Condition Data',
  '00180080': 'Repetition Time',
  '00180081': 'Echo Time',
  '00180082': 'Inversion Time',
  '00180083': 'Number of Averages',
  '00180084': 'Imaging Frequency',
  '00180085': 'Imaged Nucleus',
  '00180086': 'Echo Number(s)',
  '00180087': 'Magnetic Field Strength',
  '00180088': 'Spacing Between Slices',
  '00180089': 'Number of Phase Encoding Steps',
  '00180090': 'Data Collection Diameter',
  '00180091': 'Echo Train Length',
  '00180093': 'Percent Sampling',
  '00180094': 'Percent Phase Field of View',
  '00180095': 'Pixel Bandwidth',
  '00181000': 'Device Serial Number',
  '00181002': 'Device UID',
  '00181003': 'Device ID',
  '00181004': 'Plate ID',
  '00181005': 'Generator ID',
  '00181006': 'Grid ID',
  '00181007': 'Cassette ID',
  '00181008': 'Gantry ID',
  '00181010': 'Secondary Capture Device ID',
  '00181011': 'Hardcopy Creation Device ID',
  '00181012': 'Date of Secondary Capture',
  '00181014': 'Time of Secondary Capture',
  '00181016': 'Secondary Capture Device Manufacturer',
  '00181017': 'Hardcopy Device Manufacturer',
  '00181018': 'Secondary Capture Device Manufacturers Model Name',
  '00181019': 'Secondary Capture Device Software Versions',
  '0018101A': 'Hardcopy Device Software Version',
  '0018101B': 'Hardcopy Device Manufacturers Model Name',
  '00181020': 'Software Version(s)',
  '00181022': 'Video Image Format Acquired',
  '00181023': 'Digital Image Format Acquired',
  '00181030': 'Protocol Name',
  '00181040': 'Contrast/Bolus Route',
  '00181041': 'Contrast/Bolus Volume',
  '00181042': 'Contrast/Bolus Start Time',
  '00181043': 'Contrast/Bolus Stop Time',
  '00181044': 'Contrast/Bolus Total Dose',
  '00181045': 'Syringe Counts',
  '00181046': 'Contrast Flow Rate',
  '00181047': 'Contrast Flow Duration',
  '00181048': 'Contrast/Bolus Ingredient',
  '00181049': 'Contrast/Bolus Ingredient Concentration',
  '00181050': 'Spatial Resolution',
  '00181060': 'Trigger Time',
  '00181061': 'Trigger Source or Type',
  '00181062': 'Nominal Interval',
  '00181063': 'Frame Time',
  '00181064': 'Cardiac Framing Type',
  '00181065': 'Frame Time Vector',
  '00181066': 'Frame Delay',
  '00181067': 'Image Trigger Delay',
  '00181068': 'Multiplex Group Time Offset',
  '00181069': 'Trigger Time Offset',
  '0018106A': 'Synchronization Trigger',
  '0018106C': 'Synchronization Channel',
  '0018106E': 'Trigger Sample Position',
  '00181070': 'Radio​pharmaceutical Route',
  '00181071': 'Radio​pharmaceutical Volume',
  '00181072': 'Radio​pharmaceutical Start Time',
  '00181073': 'Radio​pharmaceutical Stop Time',
  '00181074': 'Radionuclide Total Dose',
  '00181075': 'Radionuclide Half Life',
  '00181076': 'Radionuclide Positron Fraction',
  '00181077': 'Radio​pharmaceutical Specific Activity',
  '00181078': 'Radio​pharmaceutical Start DateTime',
  '00181079': 'Radio​pharmaceutical Stop DateTime',
  '00181080': 'Beat Rejection Flag',
  '00181081': 'Low R-R Value',
  '00181082': 'High R-R Value',
  '00181083': 'Intervals Acquired',
  '00181084': 'Intervals Rejected',
  '00181085': 'PVC Rejection',
  '00181086': 'Skip Beats',
  '00181088': 'Heart Rate',
  '00181090': 'Cardiac Number of Images',
  '00181094': 'Trigger Window',
  '00181100': 'Reconstruction Diameter',
  '00181110': 'Distance Source to Detector',
  '00181111': 'Distance Source to Patient',
  '00181114': 'Estimated Radiographic Magnification Factor',
  '00181120': 'Gantry/Detector Tilt',
  '00181121': 'Gantry/Detector Slew',
  '00181130': 'Table Height',
  '00181131': 'Table Traverse',
  '00181134': 'Table Motion',
  '00181135': 'Table Vertical Increment',
  '00181136': 'Table Lateral Increment',
  '00181137': 'Table Longitudinal Increment',
  '00181138': 'Table Angle',
  '0018113A': 'Table Type',
  '00181140': 'Rotation Direction',
  '00181141': 'Angular Position',
  '00181142': 'Radial Position',
  '00181143': 'Scan Arc',
  '00181144': 'Angular Step',
  '00181145': 'Center of Rotation Offset',
  '00181146': 'Rotation Offset',
  '00181147': 'Field of View Shape',
  '00181149': 'Field of View Dimension(s)',
  '00181150': 'Exposure Time',
  '00181151': 'X-Ray Tube Current',
  '00181152': 'Exposure',
  '00181153': 'Exposure in µAs',
  '00181154': 'Average Pulse Width',
  '00181155': 'Radiation Setting',
  '00181156': 'Rectification Type',
  '0018115A': 'Radiation Mode',
  '0018115E': 'Image and Fluoroscopy Area Dose Product',
  '00181160': 'Filter Type',
  '00181161': 'Type of Filters',
  '00181162': 'Intensifier Size',
  '00181164': 'Imager Pixel Spacing',
  '00181166': 'Grid',
  '00181170': 'Generator Power',
  '00181180': 'Collimator/grid Name',
  '00181181': 'Collimator Type',
  '00181182': 'Focal Distance',
  '00181183': 'X Focus Center',
  '00181184': 'Y Focus Center',
  '00181190': 'Focal Spot(s)',
  '00181191': 'Anode Target Material',
  '001811A0': 'Body Part Thickness',
  '001811A2': 'Compression Force',
  '001811A4': 'Paddle Description',
  '00181200': 'Date of Last Calibration',
  '00181201': 'Time of Last Calibration',
  '00181210': 'Convolution Kernel',
  '00181240': 'Upper/Lower Pixel Values',
  '00181242': 'Actual Frame Duration',
  '00181243': 'Count Rate',
  '00181244': 'Preferred Playback Sequencing',
  '00181250': 'Receive Coil Name',
  '00181251': 'Transmit Coil Name',
  '00181260': 'Plate Type',
  '00181261': 'Phosphor Type',
  '00181300': 'Scan Velocity',
  '00181301': 'Whole Body Technique',
  '00181302': 'Scan Length',
  '00181310': 'Acquisition Matrix',
  '00181312': 'In-plane Phase Encoding Direction',
  '00181314': 'Flip Angle',
  '00181315': 'Variable Flip Angle Flag',
  '00181316': 'SAR',
  '00181318': 'dB/dt',
  '00181400': 'Acquisition Device Processing Description',
  '00181401': 'Acquisition Device Processing Code',
  '00181402': 'Cassette Orientation',
  '00181403': 'Cassette Size',
  '00181404': 'Exposures on Plate',
  '00181405': 'Relative X-Ray Exposure',
  '00181411': 'Exposure Index',
  '00181412': 'Target Exposure Index',
  '00181413': 'Deviation Index',
  '00181450': 'Column Angulation',
  '00181460': 'Tomo Layer Height',
  '00181470': 'Tomo Angle',
  '00181480': 'Tomo Time',
  '00181490': 'Tomo Type',
  '00181491': 'Tomo Class',
  '00181495': 'Number of Tomosynthesis Source Images',
  '00181500': 'Positioner Motion',
  '00181508': 'Positioner Type',
  '00181510': 'Positioner Primary Angle',
  '00181511': 'Positioner Secondary Angle',
  '00181520': 'Positioner Primary Angle Increment',
  '00181521': 'Positioner Secondary Angle Increment',
  '00181530': 'Detector Primary Angle',
  '00181531': 'Detector Secondary Angle',
  '00181600': 'Shutter Shape',
  '00181602': 'Shutter Left Vertical Edge',
  '00181604': 'Shutter Right Vertical Edge',
  '00181606': 'Shutter Upper Horizontal Edge',
  '00181608': 'Shutter Lower Horizontal Edge',
  '00181610': 'Center of Circular Shutter',
  '00181612': 'Radius of Circular Shutter',
  '00181620': 'Vertices of the Polygonal Shutter',
  '00181622': 'Shutter Presentation Value',
  '00181623': 'Shutter Overlay Group',
  '00181624': 'Shutter Presentation Color CIE​Lab Value',
  '00181700': 'Collimator Shape',
  '00181702': 'Collimator Left Vertical Edge',
  '00181704': 'Collimator Right Vertical Edge',
  '00181706': 'Collimator Upper Horizontal Edge',
  '00181708': 'Collimator Lower Horizontal Edge',
  '00181710': 'Center of Circular Collimator',
  '00181712': 'Radius of Circular Collimator',
  '00181720': 'Vertices of the Polygonal Collimator',
  '00181800': 'Acquisition Time Synchronized',
  '00181801': 'Time Source',
  '00181802': 'Time Distribution Protocol',
  '00181803': 'NTP Source Address',
  '00182001': 'Page Number Vector',
  '00182002': 'Frame Label Vector',
  '00182003': 'Frame Primary Angle Vector',
  '00182004': 'Frame Secondary Angle Vector',
  '00182005': 'Slice Location Vector',
  '00182006': 'Display Window Label Vector',
  '00182010': 'Nominal Scanned Pixel Spacing',
  '00182020': 'Digitizing Device Transport Direction',
  '00182030': 'Rotation of Scanned Film',
  '00182041': 'Biopsy Target Sequence',
  '00182042': 'Target UID',
  '00182043': 'Localizing Cursor Position',
  '00182044': 'Calculated Target Position',
  '00182045': 'Target Label',
  '00182046': 'Displayed Z Value',
  '00183100': 'IVUS Acquisition',
  '00183101': 'IVUS Pullback Rate',
  '00183102': 'IVUS Gated Rate',
  '00183103': 'IVUS Pullback Start Frame Number',
  '00183104': 'IVUS Pullback Stop Frame Number',
  '00183105': 'Lesion Number',
  '00184000': 'Acquisition Comments',
  '00185000': 'Output Power',
  '00185010': 'Transducer Data',
  '00185012': 'Focus Depth',
  '00185020': 'Processing Function',
  '00185021': 'Postprocessing Function',
  '00185022': 'Mechanical Index',
  '00185024': 'Bone Thermal Index',
  '00185026': 'Cranial Thermal Index',
  '00185027': 'Soft Tissue Thermal Index',
  '00185028': 'Soft Tissue-focus Thermal Index',
  '00185029': 'Soft Tissue-surface Thermal Index',
  '00185030': 'Dynamic Range',
  '00185040': 'Total Gain',
  '00185050': 'Depth of Scan Field',
  '00185100': 'Patient Position',
  '00185101': 'View Position',
  '00185104': 'Projection Eponymous Name Code Sequence',
  '00185210': 'Image Transformation Matrix',
  '00185212': 'Image Translation Vector',
  '00186000': 'Sensitivity',
  '00186011': 'Sequence of Ultrasound Regions',
  '00186012': 'Region Spatial Format',
  '00186014': 'Region Data Type',
  '00186016': 'Region Flags',
  '00186018': 'Region Location Min X0',
  '0018601A': 'Region Location Min Y0',
  '0018601C': 'Region Location Max X1',
  '0018601E': 'Region Location Max Y1',
  '00186020': 'Reference Pixel X0',
  '00186022': 'Reference Pixel Y0',
  '00186024': 'Physical Units X Direction',
  '00186026': 'Physical Units Y Direction',
  '00186028': 'Reference Pixel Physical Value X',
  '0018602A': 'Reference Pixel Physical Value Y',
  '0018602C': 'Physical Delta X',
  '0018602E': 'Physical Delta Y',
  '00186030': 'Transducer Frequency',
  '00186031': 'Transducer Type',
  '00186032': 'Pulse Repetition Frequency',
  '00186034': 'Doppler Correction Angle',
  '00186036': 'Steering Angle',
  '00186038': 'Doppler Sample Volume X Position (Retired)',
  '00186039': 'Doppler Sample Volume X Position',
  '0018603A': 'Doppler Sample Volume Y Position (Retired)',
  '0018603B': 'Doppler Sample Volume Y Position',
  '0018603C': 'TM-Line Position X0 (Retired)',
  '0018603D': 'TM-Line Position X0',
  '0018603E': 'TM-Line Position Y0 (Retired)',
  '0018603F': 'TM-Line Position Y0',
  '00186040': 'TM-Line Position X1 (Retired)',
  '00186041': 'TM-Line Position X1',
  '00186042': 'TM-Line Position Y1 (Retired)',
  '00186043': 'TM-Line Position Y1',
  '00186044': 'Pixel Component Organization',
  '00186046': 'Pixel Component Mask',
  '00186048': 'Pixel Component Range Start',
  '0018604A': 'Pixel Component Range Stop',
  '0018604C': 'Pixel Component Physical Units',
  '0018604E': 'Pixel Component Data Type',
  '00186050': 'Number of Table Break Points',
  '00186052': 'Table of X Break Points',
  '00186054': 'Table of Y Break Points',
  '00186056': 'Number of Table Entries',
  '00186058': 'Table of Pixel Values',
  '0018605A': 'Table of Parameter Values',
  '00186060': 'R Wave Time Vector',
  '00187000': 'Detector Conditions Nominal Flag',
  '00187001': 'Detector Temperature',
  '00187004': 'Detector Type',
  '00187005': 'Detector Configuration',
  '00187006': 'Detector Description',
  '00187008': 'Detector Mode',
  '0018700A': 'Detector ID',
  '0018700C': 'Date of Last Detector Calibration',
  '0018700E': 'Time of Last Detector Calibration',
  '00187010': 'Exposures on Detector Since Last Calibration',
  '00187011': 'Exposures on Detector Since Manufactured',
  '00187012': 'Detector Time Since Last Exposure',
  '00187014': 'Detector Active Time',
  '00187016': 'Detector Activation Offset From Exposure',
  '0018701A': 'Detector Binning',
  '00187020': 'Detector Element Physical Size',
  '00187022': 'Detector Element Spacing',
  '00187024': 'Detector Active Shape',
  '00187026': 'Detector Active Dimension(s)',
  '00187028': 'Detector Active Origin',
  '0018702A': 'Detector Manufacturer Name',
  '0018702B': 'Detector Manufacturers Model Name',
  '00187030': 'Field of View Origin',
  '00187032': 'Field of View Rotation',
  '00187034': 'Field of View Horizontal Flip',
  '00187036': 'Pixel Data Area Origin Relative To FOV',
  '00187038': 'Pixel Data Area Rotation Angle Relative To FOV',
  '00187040': 'Grid Absorbing Material',
  '00187041': 'Grid Spacing Material',
  '00187042': 'Grid Thickness',
  '00187044': 'Grid Pitch',
  '00187046': 'Grid Aspect Ratio',
  '00187048': 'Grid Period',
  '0018704C': 'Grid Focal Distance',
  '00187050': 'Filter Material',
  '00187052': 'Filter Thickness Minimum',
  '00187054': 'Filter Thickness Maximum',
  '00187056': 'Filter Beam Path Length Minimum',
  '00187058': 'Filter Beam Path Length Maximum',
  '00187060': 'Exposure Control Mode',
  '00187062': 'Exposure Control Mode Description',
  '00187064': 'Exposure Status',
  '00187065': 'Phototimer Setting',
  '00188150': 'Exposure Time in µS',
  '00188151': 'X-Ray Tube Current in µA',
  '00189004': 'Content Qualification',
  '00189005': 'Pulse Sequence Name',
  '00189006': 'MR Imaging Modifier Sequence',
  '00189008': 'Echo Pulse Sequence',
  '00189009': 'Inversion Recovery',
  '00189010': 'Flow Compensation',
  '00189011': 'Multiple Spin Echo',
  '00189012': 'Multi-planar Excitation',
  '00189014': 'Phase Contrast',
  '00189015': 'Time of Flight Contrast',
  '00189016': 'Spoiling',
  '00189017': 'Steady State Pulse Sequence',
  '00189018': 'Echo Planar Pulse Sequence',
  '00189019': 'Tag Angle First Axis',
  '00189020': 'Magnetization Transfer',
  '00189021': 'T2 Preparation',
  '00189022': 'Blood Signal Nulling',
  '00189024': 'Saturation Recovery',
  '00189025': 'Spectrally Selected Suppression',
  '00189026': 'Spectrally Selected Excitation',
  '00189027': 'Spatial Pre-saturation',
  '00189028': 'Tagging',
  '00189029': 'Oversampling Phase',
  '00189030': 'Tag Spacing First Dimension',
  '00189032': 'Geometry of k-Space Traversal',
  '00189033': 'Segmented k-Space Traversal',
  '00189034': 'Rectilinear Phase Encode Reordering',
  '00189035': 'Tag Thickness',
  '00189036': 'Partial Fourier Direction',
  '00189037': 'Cardiac Synchronization Technique',
  '00189041': 'Receive Coil Manufacturer Name',
  '00189042': 'MR Receive Coil Sequence',
  '00189043': 'Receive Coil Type',
  '00189044': 'Quadrature Receive Coil',
  '00189045': 'Multi-Coil Definition Sequence',
  '00189046': 'Multi-Coil Configuration',
  '00189047': 'Multi-Coil Element Name',
  '00189048': 'Multi-Coil Element Used',
  '00189049': 'MR Transmit Coil Sequence',
  '00189050': 'Transmit Coil Manufacturer Name',
  '00189051': 'Transmit Coil Type',
  '00189052': 'Spectral Width',
  '00189053': 'Chemical Shift Reference',
  '00189054': 'Volume Localization Technique',
  '00189058': 'MR Acquisition Frequency Encoding Steps',
  '00189059': 'De-coupling',
  '00189060': 'De-coupled Nucleus',
  '00189061': 'De-coupling Frequency',
  '00189062': 'De-coupling Method',
  '00189063': 'De-coupling Chemical Shift Reference',
  '00189064': 'k-space Filtering',
  '00189065': 'Time Domain Filtering',
  '00189066': 'Number of Zero Fills',
  '00189067': 'Baseline Correction',
  '00189069': 'Parallel Reduction Factor In-plane',
  '00189070': 'Cardiac R-R Interval Specified',
  '00189073': 'Acquisition Duration',
  '00189074': 'Frame Acquisition DateTime',
  '00189075': 'Diffusion Directionality',
  '00189076': 'Diffusion Gradient Direction Sequence',
  '00189077': 'Parallel Acquisition',
  '00189078': 'Parallel Acquisition Technique',
  '00189079': 'Inversion Times',
  '00189080': 'Metabolite Map Description',
  '00189081': 'Partial Fourier',
  '00189082': 'Effective Echo Time',
  '00189083': 'Metabolite Map Code Sequence',
  '00189084': 'Chemical Shift Sequence',
  '00189085': 'Cardiac Signal Source',
  '00189087': 'Diffusion b-value',
  '00189089': 'Diffusion Gradient Orientation',
  '00189090': 'Velocity Encoding Direction',
  '00189091': 'Velocity Encoding Minimum Value',
  '00189092': 'Velocity Encoding Acquisition Sequence',
  '00189093': 'Number of k-Space Trajectories',
  '00189094': 'Coverage of k-Space',
  '00189095': 'Spectroscopy Acquisition Phase Rows',
  '00189096': 'Parallel Reduction Factor In-plane (Retired)',
  '00189098': 'Transmitter Frequency',
  '00189100': 'Resonant Nucleus',
  '00189101': 'Frequency Correction',
  '00189103': 'MR Spectroscopy FOV/Geometry Sequence',
  '00189104': 'Slab Thickness',
  '00189105': 'Slab Orientation',
  '00189106': 'Mid Slab Position',
  '00189107': 'MR Spatial Saturation Sequence',
  '00189112': 'MR Timing and Related Parameters Sequence',
  '00189114': 'MR Echo Sequence',
  '00189115': 'MR Modifier Sequence',
  '00189117': 'MR Diffusion Sequence',
  '00189118': 'Cardiac Synchronization Sequence',
  '00189119': 'MR Averages Sequence',
  '00189125': 'MR FOV/Geometry Sequence',
  '00189126': 'Volume Localization Sequence',
  '00189127': 'Spectroscopy Acquisition Data Columns',
  '00189147': 'Diffusion Anisotropy Type',
  '00189151': 'Frame Reference DateTime',
  '00189152': 'MR Metabolite Map Sequence',
  '00189155': 'Parallel Reduction Factor out-of-plane',
  '00189159': 'Spectroscopy Acquisition Out-of-plane Phase Steps',
  '00189166': 'Bulk Motion Status',
  '00189168': 'Parallel Reduction Factor Second In-plane',
  '00189169': 'Cardiac Beat Rejection Technique',
  '00189170': 'Respiratory Motion Compensation Technique',
  '00189171': 'Respiratory Signal Source',
  '00189172': 'Bulk Motion Compensation Technique',
  '00189173': 'Bulk Motion Signal Source',
  '00189174': 'Applicable Safety Standard Agency',
  '00189175': 'Applicable Safety Standard Description',
  '00189176': 'Operating Mode Sequence',
  '00189177': 'Operating Mode Type',
  '00189178': 'Operating Mode',
  '00189179': 'Specific Absorption Rate Definition',
  '00189180': 'Gradient Output Type',
  '00189181': 'Specific Absorption Rate Value',
  '00189182': 'Gradient Output',
  '00189183': 'Flow Compensation Direction',
  '00189184': 'Tagging Delay',
  '00189185': 'Respiratory Motion Compensation Technique Description',
  '00189186': 'Respiratory Signal Source ID',
  '00189195': 'Chemical Shift Minimum Integration Limit in Hz',
  '00189196': 'Chemical Shift Maximum Integration Limit in Hz',
  '00189197': 'MR Velocity Encoding Sequence',
  '00189198': 'First Order Phase Correction',
  '00189199': 'Water Referenced Phase Correction',
  '00189200': 'MR Spectroscopy Acquisition Type',
  '00189214': 'Respiratory Cycle Position',
  '00189217': 'Velocity Encoding Maximum Value',
  '00189218': 'Tag Spacing Second Dimension',
  '00189219': 'Tag Angle Second Axis',
  '00189220': 'Frame Acquisition Duration',
  '00189226': 'MR Image Frame Type Sequence',
  '00189227': 'MR Spectroscopy Frame Type Sequence',
  '00189231': 'MR Acquisition Phase Encoding Steps in-plane',
  '00189232': 'MR Acquisition Phase Encoding Steps out-of-plane',
  '00189234': 'Spectroscopy Acquisition Phase Columns',
  '00189236': 'Cardiac Cycle Position',
  '00189239': 'Specific Absorption Rate Sequence',
  '00189240': 'RF Echo Train Length',
  '00189241': 'Gradient Echo Train Length',
  '00189250': 'Arterial Spin Labeling Contrast',
  '00189251': 'MR Arterial Spin Labeling Sequence',
  '00189252': 'ASL Technique Description',
  '00189253': 'ASL Slab Number',
  '00189254': 'ASL Slab Thickness',
  '00189255': 'ASL Slab Orientation',
  '00189256': 'ASL Mid Slab Position',
  '00189257': 'ASL Context',
  '00189258': 'ASL Pulse Train Duration',
  '00189259': 'ASL Crusher Flag',
  '0018925A': 'ASL Crusher Flow Limit',
  '0018925B': 'ASL Crusher Description',
  '0018925C': 'ASL Bolus Cut-off Flag',
  '0018925D': 'ASL Bolus Cut-off Timing Sequence',
  '0018925E': 'ASL Bolus Cut-off Technique',
  '0018925F': 'ASL Bolus Cut-off Delay Time',
  '00189260': 'ASL Slab Sequence',
  '00189295': 'Chemical Shift Minimum Integration Limit in ppm',
  '00189296': 'Chemical Shift Maximum Integration Limit in ppm',
  '00189301': 'CT Acquisition Type Sequence',
  '00189302': 'Acquisition Type',
  '00189303': 'Tube Angle',
  '00189304': 'CT Acquisition Details Sequence',
  '00189305': 'Revolution Time',
  '00189306': 'Single Collimation Width',
  '00189307': 'Total Collimation Width',
  '00189308': 'CT Table Dynamics Sequence',
  '00189309': 'Table Speed',
  '00189310': 'Table Feed per Rotation',
  '00189311': 'Spiral Pitch Factor',
  '00189312': 'CT Geometry Sequence',
  '00189313': 'Data Collection Center (Patient)',
  '00189314': 'CT Reconstruction Sequence',
  '00189315': 'Reconstruction Algorithm',
  '00189316': 'Convolution Kernel Group',
  '00189317': 'Reconstruction Field of View',
  '00189318': 'Reconstruction Target Center (Patient)',
  '00189319': 'Reconstruction Angle',
  '00189320': 'Image Filter',
  '00189321': 'CT Exposure Sequence',
  '00189322': 'Reconstruction Pixel Spacing',
  '00189323': 'Exposure Modulation Type',
  '00189324': 'Estimated Dose Saving',
  '00189325': 'CT X-Ray Details Sequence',
  '00189326': 'CT Position Sequence',
  '00189327': 'Table Position',
  '00189328': 'Exposure Time in ms',
  '00189329': 'CT Image Frame Type Sequence',
  '00189330': 'X-Ray Tube Current in mA',
  '00189332': 'Exposure in mAs',
  '00189333': 'Constant Volume Flag',
  '00189334': 'Fluoroscopy Flag',
  '00189335': 'Distance Source to Data Collection Center',
  '00189337': 'Contrast/Bolus Agent Number',
  '00189338': 'Contrast/Bolus Ingredient Code Sequence',
  '00189340': 'Contrast Administration Profile Sequence',
  '00189341': 'Contrast/Bolus Usage Sequence',
  '00189342': 'Contrast/Bolus Agent Administered',
  '00189343': 'Contrast/Bolus Agent Detected',
  '00189344': 'Contrast/Bolus Agent Phase',
  '00189345': 'CTD​Ivol',
  '00189346': 'CTDI Phantom Type Code Sequence',
  '00189351': 'Calcium Scoring Mass Factor Patient',
  '00189352': 'Calcium Scoring Mass Factor Device',
  '00189353': 'Energy Weighting Factor',
  '00189360': 'CT Additional X-Ray Source Sequence',
  '00189401': 'Projection Pixel Calibration Sequence',
  '00189402': 'Distance Source to Isocenter',
  '00189403': 'Distance Object to Table Top',
  '00189404': 'Object Pixel Spacing in Center of Beam',
  '00189405': 'Positioner Position Sequence',
  '00189406': 'Table Position Sequence',
  '00189407': 'Collimator Shape Sequence',
  '00189410': 'Planes in Acquisition',
  '00189412': 'XA/XRF Frame Characteristics Sequence',
  '00189417': 'Frame Acquisition Sequence',
  '00189420': 'X-Ray Receptor Type',
  '00189423': 'Acquisition Protocol Name',
  '00189424': 'Acquisition Protocol Description',
  '00189425': 'Contrast/Bolus Ingredient Opaque',
  '00189426': 'Distance Receptor Plane to Detector Housing',
  '00189427': 'Intensifier Active Shape',
  '00189428': 'Intensifier Active Dimension(s)',
  '00189429': 'Physical Detector Size',
  '00189430': 'Position of Isocenter Projection',
  '00189432': 'Field of View Sequence',
  '00189433': 'Field of View Description',
  '00189434': 'Exposure Control Sensing Regions Sequence',
  '00189435': 'Exposure Control Sensing Region Shape',
  '00189436': 'Exposure Control Sensing Region Left Vertical Edge',
  '00189437': 'Exposure Control Sensing Region Right Vertical Edge',
  '00189438': 'Exposure Control Sensing Region Upper Horizontal Edge',
  '00189439': 'Exposure Control Sensing Region Lower Horizontal Edge',
  '00189440': 'Center of Circular Exposure Control Sensing Region',
  '00189441': 'Radius of Circular Exposure Control Sensing Region',
  '00189442': 'Vertices of the Polygonal Exposure Control Sensing Region',
  '00189447': 'Column Angulation (Patient)',
  '00189449': 'Beam Angle',
  '00189451': 'Frame Detector Parameters Sequence',
  '00189452': 'Calculated Anatomy Thickness',
  '00189455': 'Calibration Sequence',
  '00189456': 'Object Thickness Sequence',
  '00189457': 'Plane Identification',
  '00189461': 'Field of View Dimension(s) in Float',
  '00189462': 'Isocenter Reference System Sequence',
  '00189463': 'Positioner Isocenter Primary Angle',
  '00189464': 'Positioner Isocenter Secondary Angle',
  '00189465': 'Positioner Isocenter Detector Rotation Angle',
  '00189466': 'Table X Position to Isocenter',
  '00189467': 'Table Y Position to Isocenter',
  '00189468': 'Table Z Position to Isocenter',
  '00189469': 'Table Horizontal Rotation Angle',
  '00189470': 'Table Head Tilt Angle',
  '00189471': 'Table Cradle Tilt Angle',
  '00189472': 'Frame Display Shutter Sequence',
  '00189473': 'Acquired Image Area Dose Product',
  '00189474': 'C-arm Positioner Tabletop Relationship',
  '00189476': 'X-Ray Geometry Sequence',
  '00189477': 'Irradiation Event Identification Sequence',
  '00189504': 'X-Ray 3D Frame Type Sequence',
  '00189506': 'Contributing Sources Sequence',
  '00189507': 'X-Ray 3D Acquisition Sequence',
  '00189508': 'Primary Positioner Scan Arc',
  '00189509': 'Secondary Positioner Scan Arc',
  '00189510': 'Primary Positioner Scan Start Angle',
  '00189511': 'Secondary Positioner Scan Start Angle',
  '00189514': 'Primary Positioner Increment',
  '00189515': 'Secondary Positioner Increment',
  '00189516': 'Start Acquisition DateTime',
  '00189517': 'End Acquisition DateTime',
  '00189524': 'Application Name',
  '00189525': 'Application Version',
  '00189526': 'Application Manufacturer',
  '00189527': 'Algorithm Type',
  '00189528': 'Algorithm Description',
  '00189530': 'X-Ray 3D Reconstruction Sequence',
  '00189531': 'Reconstruction Description',
  '00189538': 'Per Projection Acquisition Sequence',
  '00189601': 'Diffusion b-matrix Sequence',
  '00189602': 'Diffusion b-value XX',
  '00189603': 'Diffusion b-value XY',
  '00189604': 'Diffusion b-value XZ',
  '00189605': 'Diffusion b-value YY',
  '00189606': 'Diffusion b-value YZ',
  '00189607': 'Diffusion b-value ZZ',
  '00189701': 'Decay Correction DateTime',
  '00189715': 'Start Density Threshold',
  '00189716': 'Start Relative Density Difference Threshold',
  '00189717': 'Start Cardiac Trigger Count Threshold',
  '00189718': 'Start Respiratory Trigger Count Threshold',
  '00189719': 'Termination Counts Threshold',
  '00189720': 'Termination Density Threshold',
  '00189721': 'Termination Relative Density Threshold',
  '00189722': 'Termination Time Threshold',
  '00189723': 'Termination Cardiac Trigger Count Threshold',
  '00189724': 'Termination Respiratory Trigger Count Threshold',
  '00189725': 'Detector Geometry',
  '00189726': 'Transverse Detector Separation',
  '00189727': 'Axial Detector Dimension',
  '00189729': 'Radio​pharmaceutical Agent Number',
  '00189732': 'PET Frame Acquisition Sequence',
  '00189733': 'PET Detector Motion Details Sequence',
  '00189734': 'PET Table Dynamics Sequence',
  '00189735': 'PET Position Sequence',
  '00189736': 'PET Frame Correction Factors Sequence',
  '00189737': 'Radio​pharmaceutical Usage Sequence',
  '00189738': 'Attenuation Correction Source',
  '00189739': 'Number of Iterations',
  '00189740': 'Number of Subsets',
  '00189749': 'PET Reconstruction Sequence',
  '00189751': 'PET Frame Type Sequence',
  '00189755': 'Time of Flight Information Used',
  '00189756': 'Reconstruction Type',
  '00189758': 'Decay Corrected',
  '00189759': 'Attenuation Corrected',
  '00189760': 'Scatter Corrected',
  '00189761': 'Dead Time Corrected',
  '00189762': 'Gantry Motion Corrected',
  '00189763': 'Patient Motion Corrected',
  '00189764': 'Count Loss Normalization Corrected',
  '00189765': 'Randoms Corrected',
  '00189766': 'Non-uniform Radial Sampling Corrected',
  '00189767': 'Sensitivity Calibrated',
  '00189768': 'Detector Normalization Correction',
  '00189769': 'Iterative Reconstruction Method',
  '00189770': 'Attenuation Correction Temporal Relationship',
  '00189771': 'Patient Physiological State Sequence',
  '00189772': 'Patient Physiological State Code Sequence',
  '00189801': 'Depth(s) of Focus',
  '00189803': 'Excluded Intervals Sequence',
  '00189804': 'Exclusion Start DateTime',
  '00189805': 'Exclusion Duration',
  '00189806': 'US Image Description Sequence',
  '00189807': 'Image Data Type Sequence',
  '00189808': 'Data Type',
  '00189809': 'Transducer Scan Pattern Code Sequence',
  '0018980B': 'Aliased Data Type',
  '0018980C': 'Position Measuring Device Used',
  '0018980D': 'Transducer Geometry Code Sequence',
  '0018980E': 'Transducer Beam Steering Code Sequence',
  '0018980F': 'Transducer Application Code Sequence',
  '00189810': 'Zero Velocity Pixel Value',
  '0018A001': 'Contributing Equipment Sequence',
  '0018A002': 'Contribution DateTime',
  '0018A003': 'Contribution Description',
  '0020000D': 'Study Instance UID',
  '0020000E': 'Series Instance UID',
  '00200010': 'Study ID',
  '00200011': 'Series Number',
  '00200012': 'Acquisition Number',
  '00200013': 'Instance Number',
  '00200014': 'Isotope Number',
  '00200015': 'Phase Number',
  '00200016': 'Interval Number',
  '00200017': 'Time Slot Number',
  '00200018': 'Angle Number',
  '00200019': 'Item Number',
  '00200020': 'Patient Orientation',
  '00200022': 'Overlay Number',
  '00200024': 'Curve Number',
  '00200026': 'LUT Number',
  '00200030': 'Image Position',
  '00200032': 'Image Position (Patient)',
  '00200035': 'Image Orientation',
  '00200037': 'Image Orientation (Patient)',
  '00200050': 'Location',
  '00200052': 'Frame of Reference UID',
  '00200060': 'Laterality',
  '00200062': 'Image Laterality',
  '00200070': 'Image Geometry Type',
  '00200080': 'Masking Image',
  '002000AA': 'Report Number',
  '00200100': 'Temporal Position Identifier',
  '00200105': 'Number of Temporal Positions',
  '00200110': 'Temporal Resolution',
  '00200200': 'Synchronization Frame of Reference UID',
  '00200242': 'SOP Instance UID of Concatenation Source',
  '00201000': 'Series in Study',
  '00201001': 'Acquisitions in Series',
  '00201002': 'Images in Acquisition',
  '00201003': 'Images in Series',
  '00201004': 'Acquisitions in Study',
  '00201005': 'Images in Study',
  '00201020': 'Reference',
  '00201040': 'Position Reference Indicator',
  '00201041': 'Slice Location',
  '00201070': 'Other Study Numbers',
  '00201200': 'Number of Patient Related Studies',
  '00201202': 'Number of Patient Related Series',
  '00201204': 'Number of Patient Related Instances',
  '00201206': 'Number of Study Related Series',
  '00201208': 'Number of Study Related Instances',
  '00201209': 'Number of Series Related Instances',
  '002031xx': 'Source Image I​Ds',
  '00203401': 'Modifying Device ID',
  '00203402': 'Modified Image ID',
  '00203403': 'Modified Image Date',
  '00203404': 'Modifying Device Manufacturer',
  '00203405': 'Modified Image Time',
  '00203406': 'Modified Image Description',
  '00204000': 'Image Comments',
  '00205000': 'Original Image Identification',
  '00205002': 'Original Image Identification Nomenclature',
  '00209056': 'Stack ID',
  '00209057': 'In-Stack Position Number',
  '00209071': 'Frame Anatomy Sequence',
  '00209072': 'Frame Laterality',
  '00209111': 'Frame Content Sequence',
  '00209113': 'Plane Position Sequence',
  '00209116': 'Plane Orientation Sequence',
  '00209128': 'Temporal Position Index',
  '00209153': 'Nominal Cardiac Trigger Delay Time',
  '00209154': 'Nominal Cardiac Trigger Time Prior To R-Peak',
  '00209155': 'Actual Cardiac Trigger Time Prior To R-Peak',
  '00209156': 'Frame Acquisition Number',
  '00209157': 'Dimension Index Values',
  '00209158': 'Frame Comments',
  '00209161': 'Concatenation UID',
  '00209162': 'In-concatenation Number',
  '00209163': 'In-concatenation Total Number',
  '00209164': 'Dimension Organization UID',
  '00209165': 'Dimension Index Pointer',
  '00209167': 'Functional Group Pointer',
  '00209170': 'Unassigned Shared Converted Attributes Sequence',
  '00209171': 'Unassigned Per-Frame Converted Attributes Sequence',
  '00209172': 'Conversion Source Attributes Sequence',
  '00209213': 'Dimension Index Private Creator',
  '00209221': 'Dimension Organization Sequence',
  '00209222': 'Dimension Index Sequence',
  '00209228': 'Concatenation Frame Offset Number',
  '00209238': 'Functional Group Private Creator',
  '00209241': 'Nominal Percentage of Cardiac Phase',
  '00209245': 'Nominal Percentage of Respiratory Phase',
  '00209246': 'Starting Respiratory Amplitude',
  '00209247': 'Starting Respiratory Phase',
  '00209248': 'Ending Respiratory Amplitude',
  '00209249': 'Ending Respiratory Phase',
  '00209250': 'Respiratory Trigger Type',
  '00209251': 'R-R Interval Time Nominal',
  '00209252': 'Actual Cardiac Trigger Delay Time',
  '00209253': 'Respiratory Synchronization Sequence',
  '00209254': 'Respiratory Interval Time',
  '00209255': 'Nominal Respiratory Trigger Delay Time',
  '00209256': 'Respiratory Trigger Delay Threshold',
  '00209257': 'Actual Respiratory Trigger Delay Time',
  '00209301': 'Image Position (Volume)',
  '00209302': 'Image Orientation (Volume)',
  '00209307': 'Ultrasound Acquisition Geometry',
  '00209308': 'Apex Position',
  '00209309': 'Volume to Transducer Mapping Matrix',
  '0020930A': 'Volume to Table Mapping Matrix',
  '0020930C': 'Patient Frame of Reference Source',
  '0020930D': 'Temporal Position Time Offset',
  '0020930E': 'Plane Position (Volume) Sequence',
  '0020930F': 'Plane Orientation (Volume) Sequence',
  '00209310': 'Temporal Position Sequence',
  '00209311': 'Dimension Organization Type',
  '00209312': 'Volume Frame of Reference UID',
  '00209313': 'Table Frame of Reference UID',
  '00209421': 'Dimension Description Label',
  '00209450': 'Patient Orientation in Frame Sequence',
  '00209453': 'Frame Label',
  '00209518': 'Acquisition Index',
  '00209529': 'Contributing SOP Instances Reference Sequence',
  '00209536': 'Reconstruction Index',
  '00220001': 'Light Path Filter Pass-Through Wavelength',
  '00220002': 'Light Path Filter Pass Band',
  '00220003': 'Image Path Filter Pass-Through Wavelength',
  '00220004': 'Image Path Filter Pass Band',
  '00220005': 'Patient Eye Movement Commanded',
  '00220006': 'Patient Eye Movement Command Code Sequence',
  '00220007': 'Spherical Lens Power',
  '00220008': 'Cylinder Lens Power',
  '00220009': 'Cylinder Axis',
  '0022000A': 'Emmetropic Magnification',
  '0022000B': 'Intra Ocular Pressure',
  '0022000C': 'Horizontal Field of View',
  '0022000D': 'Pupil Dilated',
  '0022000E': 'Degree of Dilation',
  '00220010': 'Stereo Baseline Angle',
  '00220011': 'Stereo Baseline Displacement',
  '00220012': 'Stereo Horizontal Pixel Offset',
  '00220013': 'Stereo Vertical Pixel Offset',
  '00220014': 'Stereo Rotation',
  '00220015': 'Acquisition Device Type Code Sequence',
  '00220016': 'Illumination Type Code Sequence',
  '00220017': 'Light Path Filter Type Stack Code Sequence',
  '00220018': 'Image Path Filter Type Stack Code Sequence',
  '00220019': 'Lenses Code Sequence',
  '0022001A': 'Channel Description Code Sequence',
  '0022001B': 'Refractive State Sequence',
  '0022001C': 'Mydriatic Agent Code Sequence',
  '0022001D': 'Relative Image Position Code Sequence',
  '0022001E': 'Camera Angle of View',
  '00220020': 'Stereo Pairs Sequence',
  '00220021': 'Left Image Sequence',
  '00220022': 'Right Image Sequence',
  '00220030': 'Axial Length of the Eye',
  '00220031': 'Ophthalmic Frame Location Sequence',
  '00220032': 'Reference Coordinates',
  '00220035': 'Depth Spatial Resolution',
  '00220036': 'Maximum Depth Distortion',
  '00220037': 'Along-scan Spatial Resolution',
  '00220038': 'Maximum Along-scan Distortion',
  '00220039': 'Ophthalmic Image Orientation',
  '00220041': 'Depth of Transverse Image',
  '00220042': 'Mydriatic Agent Concentration Units Sequence',
  '00220048': 'Across-scan Spatial Resolution',
  '00220049': 'Maximum Across-scan Distortion',
  '0022004E': 'Mydriatic Agent Concentration',
  '00220055': 'Illumination Wave Length',
  '00220056': 'Illumination Power',
  '00220057': 'Illumination Bandwidth',
  '00220058': 'Mydriatic Agent Sequence',
  '00221007': 'Ophthalmic Axial Measurements Right Eye Sequence',
  '00221008': 'Ophthalmic Axial Measurements Left Eye Sequence',
  '00221009': 'Ophthalmic Axial Measurements Device Type',
  '00221010': 'Ophthalmic Axial Length Measurements Type',
  '00221012': 'Ophthalmic Axial Length Sequence',
  '00221019': 'Ophthalmic Axial Length',
  '00221024': 'Lens Status Code Sequence',
  '00221025': 'Vitreous Status Code Sequence',
  '00221028': 'IOL Formula Code Sequence',
  '00221029': 'IOL Formula Detail',
  '00221033': 'Keratometer Index',
  '00221035': 'Source of Ophthalmic Axial Length Code Sequence',
  '00221037': 'Target Refraction',
  '00221039': 'Refractive Procedure Occurred',
  '00221040': 'Refractive Surgery Type Code Sequence',
  '00221044': 'Ophthalmic Ultrasound Method Code Sequence',
  '00221050': 'Ophthalmic Axial Length Measurements Sequence',
  '00221053': 'IOL Power',
  '00221054': 'Predicted Refractive Error',
  '00221059': 'Ophthalmic Axial Length Velocity',
  '00221065': 'Lens Status Description',
  '00221066': 'Vitreous Status Description',
  '00221090': 'IOL Power Sequence',
  '00221092': 'Lens Constant Sequence',
  '00221093': 'IOL Manufacturer',
  '00221094': 'Lens Constant Description',
  '00221095': 'Implant Name',
  '00221096': 'Keratometry Measurement Type Code Sequence',
  '00221097': 'Implant Part Number',
  '00221100': 'Referenced Ophthalmic Axial Measurements Sequence',
  '00221101': 'Ophthalmic Axial Length Measurements Segment Name Code Sequence',
  '00221103': 'Refractive Error Before Refractive Surgery Code Sequence',
  '00221121': 'IOL Power For Exact Emmetropia',
  '00221122': 'IOL Power For Exact Target Refraction',
  '00221125': 'Anterior Chamber Depth Definition Code Sequence',
  '00221127': 'Lens Thickness Sequence',
  '00221128': 'Anterior Chamber Depth Sequence',
  '00221130': 'Lens Thickness',
  '00221131': 'Anterior Chamber Depth',
  '00221132': 'Source of Lens Thickness Data Code Sequence',
  '00221133': 'Source of Anterior Chamber Depth Data Code Sequence',
  '00221134': 'Source of Refractive Measurements Sequence',
  '00221135': 'Source of Refractive Measurements Code Sequence',
  '00221140': 'Ophthalmic Axial Length Measurement Modified',
  '00221150': 'Ophthalmic Axial Length Data Source Code Sequence',
  '00221153': 'Ophthalmic Axial Length Acquisition Method Code Sequence',
  '00221155': 'Signal to Noise Ratio',
  '00221159': 'Ophthalmic Axial Length Data Source Description',
  '00221210': 'Ophthalmic Axial Length Measurements Total Length Sequence',
  '00221211': 'Ophthalmic Axial Length Measurements Segmental Length Sequence',
  '00221212': 'Ophthalmic Axial Length Measurements Length Summation Sequence',
  '00221220': 'Ultrasound Ophthalmic Axial Length Measurements Sequence',
  '00221225': 'Optical Ophthalmic Axial Length Measurements Sequence',
  '00221230': 'Ultrasound Selected Ophthalmic Axial Length Sequence',
  '00221250': 'Ophthalmic Axial Length Selection Method Code Sequence',
  '00221255': 'Optical Selected Ophthalmic Axial Length Sequence',
  '00221257': 'Selected Segmental Ophthalmic Axial Length Sequence',
  '00221260': 'Selected Total Ophthalmic Axial Length Sequence',
  '00221262': 'Ophthalmic Axial Length Quality Metric Sequence',
  '00221265': 'Ophthalmic Axial Length Quality Metric Type Code Sequence',
  '00221273': 'Ophthalmic Axial Length Quality Metric Type Description',
  '00221300': 'Intraocular Lens Calculations Right Eye Sequence',
  '00221310': 'Intraocular Lens Calculations Left Eye Sequence',
  '00221330': 'Referenced Ophthalmic Axial Length Measurement QC Image Sequence',
  '00221415': 'Ophthalmic Mapping Device Type',
  '00221420': 'Acquisition Method Code Sequence',
  '00221423': 'Acquisition Method Algorithm Sequence',
  '00221436': 'Ophthalmic Thickness Map Type Code Sequence',
  '00221443': 'Ophthalmic Thickness Mapping Normals Sequence',
  '00221445': 'Retinal Thickness Definition Code Sequence',
  '00221450': 'Pixel Value Mapping to Coded Concept Sequence',
  '00221452': 'Mapped Pixel Value',
  '00221454': 'Pixel Value Mapping Explanation',
  '00221458': 'Ophthalmic Thickness Map Quality Threshold Sequence',
  '00221460': 'Ophthalmic Thickness Map Threshold Quality Rating',
  '00221463': 'Anatomic Structure Reference Point',
  '00221465': 'Registration to Localizer Sequence',
  '00221466': 'Registered Localizer Units',
  '00221467': 'Registered Localizer Top Left Hand Corner',
  '00221468': 'Registered Localizer Bottom Right Hand Corner',
  '00221470': 'Ophthalmic Thickness Map Quality Rating Sequence',
  '00221472': 'Relevant OPT Attributes Sequence',
  '00240010': 'Visual Field Horizontal Extent',
  '00240011': 'Visual Field Vertical Extent',
  '00240012': 'Visual Field Shape',
  '00240016': 'Screening Test Mode Code Sequence',
  '00240018': 'Maximum Stimulus Luminance',
  '00240020': 'Background Luminance',
  '00240021': 'Stimulus Color Code Sequence',
  '00240024': 'Background Illumination Color Code Sequence',
  '00240025': 'Stimulus Area',
  '00240028': 'Stimulus Presentation Time',
  '00240032': 'Fixation Sequence',
  '00240033': 'Fixation Monitoring Code Sequence',
  '00240034': 'Visual Field Catch Trial Sequence',
  '00240035': 'Fixation Checked Quantity',
  '00240036': 'Patient Not Properly Fixated Quantity',
  '00240037': 'Presented Visual Stimuli Data Flag',
  '00240038': 'Number of Visual Stimuli',
  '00240039': 'Excessive Fixation Losses Data Flag',
  '00240040': 'Excessive Fixation Losses',
  '00240042': 'Stimuli Retesting Quantity',
  '00240044': 'Comments on Patients Performance of Visual Field',
  '00240045': 'False Negatives Estimate Flag',
  '00240046': 'False Negatives Estimate',
  '00240048': 'Negative Catch Trials Quantity',
  '00240050': 'False Negatives Quantity',
  '00240051': 'Excessive False Negatives Data Flag',
  '00240052': 'Excessive False Negatives',
  '00240053': 'False Positives Estimate Flag',
  '00240054': 'False Positives Estimate',
  '00240055': 'Catch Trials Data Flag',
  '00240056': 'Positive Catch Trials Quantity',
  '00240057': 'Test Point Normals Data Flag',
  '00240058': 'Test Point Normals Sequence',
  '00240059': 'Global Deviation Probability Normals Flag',
  '00240060': 'False Positives Quantity',
  '00240061': 'Excessive False Positives Data Flag',
  '00240062': 'Excessive False Positives',
  '00240063': 'Visual Field Test Normals Flag',
  '00240064': 'Results Normals Sequence',
  '00240065': 'Age Corrected Sensitivity Deviation Algorithm Sequence',
  '00240066': 'Global Deviation From Normal',
  '00240067': 'Generalized Defect Sensitivity Deviation Algorithm Sequence',
  '00240068': 'Localized Deviation From Normal',
  '00240069': 'Patient Reliability Indicator',
  '00240070': 'Visual Field Mean Sensitivity',
  '00240071': 'Global Deviation Probability',
  '00240072': 'Local Deviation Probability Normals Flag',
  '00240073': 'Localized Deviation Probability',
  '00240074': 'Short Term Fluctuation Calculated',
  '00240075': 'Short Term Fluctuation',
  '00240076': 'Short Term Fluctuation Probability Calculated',
  '00240077': 'Short Term Fluctuation Probability',
  '00240078': 'Corrected Localized Deviation From Normal Calculated',
  '00240079': 'Corrected Localized Deviation From Normal',
  '00240080': 'Corrected Localized Deviation From Normal Probability Calculated',
  '00240081': 'Corrected Localized Deviation From Normal Probability',
  '00240083': 'Global Deviation Probability Sequence',
  '00240085': 'Localized Deviation Probability Sequence',
  '00240086': 'Foveal Sensitivity Measured',
  '00240087': 'Foveal Sensitivity',
  '00240088': 'Visual Field Test Duration',
  '00240089': 'Visual Field Test Point Sequence',
  '00240090': 'Visual Field Test Point X-Coordinate',
  '00240091': 'Visual Field Test Point Y-Coordinate',
  '00240092': 'Age Corrected Sensitivity Deviation Value',
  '00240093': 'Stimulus Results',
  '00240094': 'Sensitivity Value',
  '00240095': 'Retest Stimulus Seen',
  '00240096': 'Retest Sensitivity Value',
  '00240097': 'Visual Field Test Point Normals Sequence',
  '00240098': 'Quantified Defect',
  '00240100': 'Age Corrected Sensitivity Deviation Probability Value',
  '00240102': 'Generalized Defect Corrected Sensitivity Deviation Flag',
  '00240103': 'Generalized Defect Corrected Sensitivity Deviation Value',
  '00240104': 'Generalized Defect Corrected Sensitivity Deviation Probability Value',
  '00240105': 'Minimum Sensitivity Value',
  '00240106': 'Blind Spot Localized',
  '00240107': 'Blind Spot X-Coordinate',
  '00240108': 'Blind Spot Y-Coordinate',
  '00240110': 'Visual Acuity Measurement Sequence',
  '00240112': 'Refractive Parameters Used on Patient Sequence',
  '00240113': 'Measurement Laterality',
  '00240114': 'Ophthalmic Patient Clinical Information Left Eye Sequence',
  '00240115': 'Ophthalmic Patient Clinical Information Right Eye Sequence',
  '00240117': 'Foveal Point Normative Data Flag',
  '00240118': 'Foveal Point Probability Value',
  '00240120': 'Screening Baseline Measured',
  '00240122': 'Screening Baseline Measured Sequence',
  '00240124': 'Screening Baseline Type',
  '00240126': 'Screening Baseline Value',
  '00240202': 'Algorithm Source',
  '00240306': 'Data Set Name',
  '00240307': 'Data Set Version',
  '00240308': 'Data Set Source',
  '00240309': 'Data Set Description',
  '00240317': 'Visual Field Test Reliability Global Index Sequence',
  '00240320': 'Visual Field Global Results Index Sequence',
  '00240325': 'Data Observation Sequence',
  '00240338': 'Index Normals Flag',
  '00240341': 'Index Probability',
  '00240344': 'Index Probability Sequence',
  '00280002': 'Samples per Pixel',
  '00280003': 'Samples per Pixel Used',
  '00280004': 'Photometric Interpretation',
  '00280005': 'Image Dimensions',
  '00280006': 'Planar Configuration',
  '00280008': 'Number of Frames',
  '00280009': 'Frame Increment Pointer',
  '0028000A': 'Frame Dimension Pointer',
  '00280010': 'Rows',
  '00280011': 'Columns',
  '00280012': 'Planes',
  '00280014': 'Ultrasound Color Data Present',
  '00280030': 'Pixel Spacing',
  '00280031': 'Zoom Factor',
  '00280032': 'Zoom Center',
  '00280034': 'Pixel Aspect Ratio',
  '00280040': 'Image Format',
  '00280050': 'Manipulated Image',
  '00280051': 'Corrected Image',
  '0028005F': 'Compression Recognition Code',
  '00280060': 'Compression Code',
  '00280061': 'Compression Originator',
  '00280062': 'Compression Label',
  '00280063': 'Compression Description',
  '00280065': 'Compression Sequence',
  '00280066': 'Compression Step Pointers',
  '00280068': 'Repeat Interval',
  '00280069': 'Bits Grouped',
  '00280070': 'Perimeter Table',
  '00280071': 'Perimeter Value',
  '00280080': 'Predictor Rows',
  '00280081': 'Predictor Columns',
  '00280082': 'Predictor Constants',
  '00280090': 'Blocked Pixels',
  '00280091': 'Block Rows',
  '00280092': 'Block Columns',
  '00280093': 'Row Overlap',
  '00280094': 'Column Overlap',
  '00280100': 'Bits Allocated',
  '00280101': 'Bits Stored',
  '00280102': 'High Bit',
  '00280103': 'Pixel Representation',
  '00280104': 'Smallest Valid Pixel Value',
  '00280105': 'Largest Valid Pixel Value',
  '00280106': 'Smallest Image Pixel Value',
  '00280107': 'Largest Image Pixel Value',
  '00280108': 'Smallest Pixel Value in Series',
  '00280109': 'Largest Pixel Value in Series',
  '00280110': 'Smallest Image Pixel Value in Plane',
  '00280111': 'Largest Image Pixel Value in Plane',
  '00280120': 'Pixel Padding Value',
  '00280121': 'Pixel Padding Range Limit',
  '00280200': 'Image Location',
  '00280300': 'Quality Control Image',
  '00280301': 'Burned In Annotation',
  '00280302': 'Recognizable Visual Features',
  '00280303': 'Longitudinal Temporal Information Modified',
  '00280304': 'Referenced Color Palette Instance UID',
  '00280400': 'Transform Label',
  '00280401': 'Transform Version Number',
  '00280402': 'Number of Transform Steps',
  '00280403': 'Sequence of Compressed Data',
  '00280404': 'Details of Coefficients',
  '002804x0': 'Rows For Nth Order Coefficients',
  '002804x1': 'Columns For Nth Order Coefficients',
  '002804x2': 'Coefficient Coding',
  '002804x3': 'Coefficient Coding Pointers',
  '00280700': 'DCT Label',
  '00280701': 'Data Block Description',
  '00280702': 'Data Block',
  '00280710': 'Normalization Factor Format',
  '00280720': 'Zonal Map Number Format',
  '00280721': 'Zonal Map Location',
  '00280722': 'Zonal Map Format',
  '00280730': 'Adaptive Map Format',
  '00280740': 'Code Number Format',
  '002808x0': 'Code Label',
  '002808x2': 'Number of Tables',
  '002808x3': 'Code Table Location',
  '002808x4': 'Bits For Code Word',
  '002808x8': 'Image Data Location',
  '00280A02': 'Pixel Spacing Calibration Type',
  '00280A04': 'Pixel Spacing Calibration Description',
  '00281040': 'Pixel Intensity Relationship',
  '00281041': 'Pixel Intensity Relationship Sign',
  '00281050': 'Window Center',
  '00281051': 'Window Width',
  '00281052': 'Rescale Intercept',
  '00281053': 'Rescale Slope',
  '00281054': 'Rescale Type',
  '00281055': 'Window Center & Width Explanation',
  '00281056': 'VOI LUT Function',
  '00281080': 'Gray Scale',
  '00281090': 'Recommended Viewing Mode',
  '00281100': 'Gray Lookup Table Descriptor',
  '00281101': 'Red Palette Color Lookup Table Descriptor',
  '00281102': 'Green Palette Color Lookup Table Descriptor',
  '00281103': 'Blue Palette Color Lookup Table Descriptor',
  '00281104': 'Alpha​Palette Color​Lookup Table Descriptor',
  '00281111': 'Large Red Palette Color Lookup Table Descriptor',
  '00281112': 'Large Green Palette Color Lookup Table Descriptor',
  '00281113': 'Large Blue Palette Color Lookup Table Descriptor',
  '00281199': 'Palette Color Lookup Table UID',
  '00281200': 'Gray Lookup Table Data',
  '00281201': 'Red Palette Color Lookup Table Data',
  '00281202': 'Green Palette Color Lookup Table Data',
  '00281203': 'Blue Palette Color Lookup Table Data',
  '00281204': 'Alpha Palette Color Lookup Table Data',
  '00281211': 'Large Red Palette Color Lookup Table Data',
  '00281212': 'Large Green Palette Color Lookup Table Data',
  '00281213': 'Large Blue Palette Color Lookup Table Data',
  '00281214': 'Large Palette Color Lookup Table UID',
  '00281221': 'Segmented Red Palette Color Lookup Table Data',
  '00281222': 'Segmented Green Palette Color Lookup Table Data',
  '00281223': 'Segmented Blue Palette Color Lookup Table Data',
  '00281300': 'Breast Implant Present',
  '00281350': 'Partial View',
  '00281351': 'Partial View Description',
  '00281352': 'Partial View Code Sequence',
  '0028135A': 'Spatial Locations Preserved',
  '00281401': 'Data Frame Assignment Sequence',
  '00281402': 'Data Path Assignment',
  '00281403': 'Bits Mapped to Color Lookup Table',
  '00281404': 'Blending LUT 1 Sequence',
  '00281405': 'Blending LUT 1 Transfer Function',
  '00281406': 'Blending Weight Constant',
  '00281407': 'Blending Lookup Table Descriptor',
  '00281408': 'Blending Lookup Table Data',
  '0028140B': 'Enhanced Palette Color Lookup Table Sequence',
  '0028140C': 'Blending LUT 2 Sequence',
  '0028140D': 'Blending LUT 2 Transfer Function',
  '0028140E': 'Data Path ID',
  '0028140F': 'RGB LUT Transfer Function',
  '00281410': 'Alpha LUT Transfer Function',
  '00282000': 'ICC Profile',
  '00282110': 'Lossy Image Compression',
  '00282112': 'Lossy Image Compression Ratio',
  '00282114': 'Lossy Image Compression Method',
  '00283000': 'Modality LUT Sequence',
  '00283002': 'LUT Descriptor',
  '00283003': 'LUT Explanation',
  '00283004': 'Modality LUT Type',
  '00283006': 'LUT Data',
  '00283010': 'VOI LUT Sequence',
  '00283110': 'Softcopy VOI LUT Sequence',
  '00284000': 'Image Presentation Comments',
  '00285000': 'Bi-Plane Acquisition Sequence',
  '00286010': 'Representative Frame Number',
  '00286020': 'Frame Numbers of Interest (FOI)',
  '00286022': 'Frame of Interest Description',
  '00286023': 'Frame of Interest Type',
  '00286030': 'Mask Pointer(s)',
  '00286040': 'R Wave Pointer',
  '00286100': 'Mask Subtraction Sequence',
  '00286101': 'Mask Operation',
  '00286102': 'Applicable Frame Range',
  '00286110': 'Mask Frame Numbers',
  '00286112': 'Contrast Frame Averaging',
  '00286114': 'Mask Sub-pixel Shift',
  '00286120': 'TID Offset',
  '00286190': 'Mask Operation Explanation',
  '00287FE0': 'Pixel Data Provider URL',
  '00289001': 'Data Point Rows',
  '00289002': 'Data Point Columns',
  '00289003': 'Signal Domain Columns',
  '00289099': 'Largest Monochrome Pixel Value',
  '00289108': 'Data Representation',
  '00289110': 'Pixel Measures Sequence',
  '00289132': 'Frame VOI LUT Sequence',
  '00289145': 'Pixel Value Transformation Sequence',
  '00289235': 'Signal Domain Rows',
  '00289411': 'Display Filter Percentage',
  '00289415': 'Frame Pixel Shift Sequence',
  '00289416': 'Subtraction Item ID',
  '00289422': 'Pixel Intensity Relationship LUT Sequence',
  '00289443': 'Frame Pixel Data Properties Sequence',
  '00289444': 'Geometrical Properties',
  '00289445': 'Geometric Maximum Distortion',
  '00289446': 'Image Processing Applied',
  '00289454': 'Mask Selection Mode',
  '00289474': 'LUT Function',
  '00289478': 'Mask Visibility Percentage',
  '00289501': 'Pixel Shift Sequence',
  '00289502': 'Region Pixel Shift Sequence',
  '00289503': 'Vertices of the Region',
  '00289505': 'Multi-frame Presentation Sequence',
  '00289506': 'Pixel Shift Frame Range',
  '00289507': 'LUT Frame Range',
  '00289520': 'Image to Equipment Mapping Matrix',
  '00289537': 'Equipment Coordinate System Identification',
  '0032000A': 'Study Status ID',
  '0032000C': 'Study Priority ID',
  '00320012': 'Study ID Issuer',
  '00320032': 'Study Verified Date',
  '00320033': 'Study Verified Time',
  '00320034': 'Study Read Date',
  '00320035': 'Study Read Time',
  '00321000': 'Scheduled Study Start Date',
  '00321001': 'Scheduled Study Start Time',
  '00321010': 'Scheduled Study Stop Date',
  '00321011': 'Scheduled Study Stop Time',
  '00321020': 'Scheduled Study Location',
  '00321021': 'Scheduled Study Location AE Title',
  '00321030': 'Reason for Study',
  '00321031': 'Requesting Physician Identification Sequence',
  '00321032': 'Requesting Physician',
  '00321033': 'Requesting Service',
  '00321034': 'Requesting Service Code Sequence',
  '00321040': 'Study Arrival Date',
  '00321041': 'Study Arrival Time',
  '00321050': 'Study Completion Date',
  '00321051': 'Study Completion Time',
  '00321055': 'Study Component Status ID',
  '00321060': 'Requested Procedure Description',
  '00321064': 'Requested Procedure Code Sequence',
  '00321070': 'Requested Contrast Agent',
  '00324000': 'Study Comments',
  '00380004': 'Referenced Patient Alias Sequence',
  '00380008': 'Visit Status ID',
  '00380010': 'Admission ID',
  '00380011': 'Issuer of Admission ID',
  '00380014': 'Issuer of Admission ID Sequence',
  '00380016': 'Route of Admissions',
  '0038001A': 'Scheduled Admission Date',
  '0038001B': 'Scheduled Admission Time',
  '0038001C': 'Scheduled Discharge Date',
  '0038001D': 'Scheduled Discharge Time',
  '0038001E': 'Scheduled Patient Institution Residence',
  '00380020': 'Admitting Date',
  '00380021': 'Admitting Time',
  '00380030': 'Discharge Date',
  '00380032': 'Discharge Time',
  '00380040': 'Discharge Diagnosis Description',
  '00380044': 'Discharge Diagnosis Code Sequence',
  '00380050': 'Special Needs',
  '00380060': 'Service Episode ID',
  '00380061': 'Issuer of Service Episode ID',
  '00380062': 'Service Episode Description',
  '00380064': 'Issuer of Service Episode ID Sequence',
  '00380100': 'Pertinent Documents Sequence',
  '00380300': 'Current Patient Location',
  '00380400': 'Patients Institution Residence',
  '00380500': 'Patient State',
  '00380502': 'Patient Clinical Trial Participation Sequence',
  '00384000': 'Visit Comments',
  '003A0004': 'Waveform Originality',
  '003A0005': 'Number of Waveform Channels',
  '003A0010': 'Number of Waveform Samples',
  '003A001A': 'Sampling Frequency',
  '003A0020': 'Multiplex Group Label',
  '003A0200': 'Channel Definition Sequence',
  '003A0202': 'Waveform Channel Number',
  '003A0203': 'Channel Label',
  '003A0205': 'Channel Status',
  '003A0208': 'Channel Source Sequence',
  '003A0209': 'Channel Source Modifiers Sequence',
  '003A020A': 'Source Waveform Sequence',
  '003A020C': 'Channel Derivation Description',
  '003A0210': 'Channel Sensitivity',
  '003A0211': 'Channel Sensitivity Units Sequence',
  '003A0212': 'Channel Sensitivity Correction Factor',
  '003A0213': 'Channel Baseline',
  '003A0214': 'Channel Time Skew',
  '003A0215': 'Channel Sample Skew',
  '003A0218': 'Channel Offset',
  '003A021A': 'Waveform Bits Stored',
  '003A0220': 'Filter Low Frequency',
  '003A0221': 'Filter High Frequency',
  '003A0222': 'Notch Filter Frequency',
  '003A0223': 'Notch Filter Bandwidth',
  '003A0230': 'Waveform Data Display Scale',
  '003A0231': 'Waveform Display Background CIE​Lab Value',
  '003A0240': 'Waveform Presentation Group Sequence',
  '003A0241': 'Presentation Group Number',
  '003A0242': 'Channel Display Sequence',
  '003A0244': 'Channel Recommended Display CIE​Lab Value',
  '003A0245': 'Channel Position',
  '003A0246': 'Display Shading Flag',
  '003A0247': 'Fractional Channel Display Scale',
  '003A0248': 'Absolute Channel Display Scale',
  '003A0300': 'Multiplexed Audio Channels Description Code Sequence',
  '003A0301': 'Channel Identification Code',
  '003A0302': 'Channel Mode',
  '00400001': 'Scheduled Station AE Title',
  '00400002': 'Scheduled Procedure Step Start Date',
  '00400003': 'Scheduled Procedure Step Start Time',
  '00400004': 'Scheduled Procedure Step End Date',
  '00400005': 'Scheduled Procedure Step End Time',
  '00400006': 'Scheduled Performing Physicians Name',
  '00400007': 'Scheduled Procedure Step Description',
  '00400008': 'Scheduled Protocol Code Sequence',
  '00400009': 'Scheduled Procedure Step ID',
  '0040000A': 'Stage Code Sequence',
  '0040000B': 'Scheduled Performing Physician Identification Sequence',
  '00400010': 'Scheduled Station Name',
  '00400011': 'Scheduled Procedure Step Location',
  '00400012': 'Pre-Medication',
  '00400020': 'Scheduled Procedure Step Status',
  '00400026': 'Order Placer Identifier Sequence',
  '00400027': 'Order Filler Identifier Sequence',
  '00400031': 'Local Namespace Entity ID',
  '00400032': 'Universal Entity ID',
  '00400033': 'Universal Entity ID Type',
  '00400035': 'Identifier Type Code',
  '00400036': 'Assigning Facility Sequence',
  '00400039': 'Assigning Jurisdiction Code Sequence',
  '0040003A': 'Assigning Agency or Department Code Sequence',
  '00400100': 'Scheduled Procedure Step Sequence',
  '00400220': 'Referenced Non-Image Composite SOP Instance Sequence',
  '00400241': 'Performed Station AE Title',
  '00400242': 'Performed Station Name',
  '00400243': 'Performed Location',
  '00400244': 'Performed Procedure Step Start Date',
  '00400245': 'Performed Procedure Step Start Time',
  '00400250': 'Performed Procedure Step End Date',
  '00400251': 'Performed Procedure Step End Time',
  '00400252': 'Performed Procedure Step Status',
  '00400253': 'Performed Procedure Step ID',
  '00400254': 'Performed Procedure Step Description',
  '00400255': 'Performed Procedure Type Description',
  '00400260': 'Performed Protocol Code Sequence',
  '00400261': 'Performed Protocol Type',
  '00400270': 'Scheduled Step Attributes Sequence',
  '00400275': 'Request Attributes Sequence',
  '00400280': 'Comments on the Performed Procedure Step',
  '00400281': 'Performed Procedure Step Discontinuation Reason Code Sequence',
  '00400293': 'Quantity Sequence',
  '00400294': 'Quantity',
  '00400295': 'Measuring Units Sequence',
  '00400296': 'Billing Item Sequence',
  '00400300': 'Total Time of Fluoroscopy',
  '00400301': 'Total Number of Exposures',
  '00400302': 'Entrance Dose',
  '00400303': 'Exposed Area',
  '00400306': 'Distance Source to Entrance',
  '00400307': 'Distance Source to Support',
  '0040030E': 'Exposure Dose Sequence',
  '00400310': 'Comments on Radiation Dose',
  '00400312': 'X-Ray Output',
  '00400314': 'Half Value Layer',
  '00400316': 'Organ Dose',
  '00400318': 'Organ Exposed',
  '00400320': 'Billing Procedure Step Sequence',
  '00400321': 'Film Consumption Sequence',
  '00400324': 'Billing Supplies and Devices Sequence',
  '00400330': 'Referenced Procedure Step Sequence',
  '00400340': 'Performed Series Sequence',
  '00400400': 'Comments on the Scheduled Procedure Step',
  '00400440': 'Protocol Context Sequence',
  '00400441': 'Content Item Modifier Sequence',
  '00400500': 'Scheduled Specimen Sequence',
  '0040050A': 'Specimen Accession Number',
  '00400512': 'Container Identifier',
  '00400513': 'Issuer of the Container Identifier Sequence',
  '00400515': 'Alternate Container Identifier Sequence',
  '00400518': 'Container Type Code Sequence',
  '0040051A': 'Container Description',
  '00400520': 'Container Component Sequence',
  '00400550': 'Specimen Sequence',
  '00400551': 'Specimen Identifier',
  '00400552': 'Specimen Description Sequence (Trial)',
  '00400553': 'Specimen Description (Trial)',
  '00400554': 'Specimen UID',
  '00400555': 'Acquisition Context Sequence',
  '00400556': 'Acquisition Context Description',
  '0040059A': 'Specimen Type Code Sequence',
  '00400560': 'Specimen Description Sequence',
  '00400562': 'Issuer of the Specimen Identifier Sequence',
  '00400600': 'Specimen Short Description',
  '00400602': 'Specimen Detailed Description',
  '00400610': 'Specimen Preparation Sequence',
  '00400612': 'Specimen Preparation Step Content Item Sequence',
  '00400620': 'Specimen Localization Content Item Sequence',
  '004006FA': 'Slide Identifier',
  '0040071A': 'Image Center Point Coordinates Sequence',
  '0040072A': 'X Offset in Slide Coordinate System',
  '0040073A': 'Y Offset in Slide Coordinate System',
  '0040074A': 'Z Offset in Slide Coordinate System',
  '004008D8': 'Pixel Spacing Sequence',
  '004008DA': 'Coordinate System Axis Code Sequence',
  '004008EA': 'Measurement Units Code Sequence',
  '004009F8': 'Vital Stain Code Sequence (Trial)',
  '00401001': 'Requested Procedure ID',
  '00401002': 'Reason for the Requested Procedure',
  '00401003': 'Requested Procedure Priority',
  '00401004': 'Patient Transport Arrangements',
  '00401005': 'Requested Procedure Location',
  '00401006': 'Placer Order Number / Procedure',
  '00401007': 'Filler Order Number / Procedure',
  '00401008': 'Confidentiality Code',
  '00401009': 'Reporting Priority',
  '0040100A': 'Reason for Requested Procedure Code Sequence',
  '00401010': 'Names of Intended Recipients of Results',
  '00401011': 'Intended Recipients of Results Identification Sequence',
  '00401012': 'Reason For Performed Procedure Code Sequence',
  '00401060': 'Requested Procedure Description (Trial)',
  '00401101': 'Person Identification Code Sequence',
  '00401102': 'Persons Address',
  '00401103': 'Persons Telephone Numbers',
  '00401400': 'Requested Procedure Comments',
  '00402001': 'Reason for the Imaging Service Request',
  '00402004': 'Issue Date of Imaging Service Request',
  '00402005': 'Issue Time of Imaging Service Request',
  '00402006': 'Placer Order Number / Imaging Service Request (Retired)',
  '00402007': 'Filler Order Number / Imaging Service Request (Retired)',
  '00402008': 'Order Entered By',
  '00402009': 'Order Enterers Location',
  '00402010': 'Order Callback Phone Number',
  '00402016': 'Placer Order Number / Imaging Service Request',
  '00402017': 'Filler Order Number / Imaging Service Request',
  '00402400': 'Imaging Service Request Comments',
  '00403001': 'Confidentiality Constraint on Patient Data Description',
  '00404001': 'General Purpose Scheduled Procedure Step Status',
  '00404002': 'General Purpose Performed Procedure Step Status',
  '00404003': 'General Purpose Scheduled Procedure Step Priority',
  '00404004': 'Scheduled Processing Applications Code Sequence',
  '00404005': 'Scheduled Procedure Step Start DateTime',
  '00404006': 'Multiple Copies Flag',
  '00404007': 'Performed Processing Applications Code Sequence',
  '00404009': 'Human Performer Code Sequence',
  '00404010': 'Scheduled Procedure Step Modification DateTime',
  '00404011': 'Expected Completion DateTime',
  '00404015': 'Resulting General Purpose Performed Procedure Steps Sequence',
  '00404016': 'Referenced General Purpose Scheduled Procedure Step Sequence',
  '00404018': 'Scheduled Workitem Code Sequence',
  '00404019': 'Performed Workitem Code Sequence',
  '00404020': 'Input Availability Flag',
  '00404021': 'Input Information Sequence',
  '00404022': 'Relevant Information Sequence',
  '00404023': 'Referenced General Purpose Scheduled Procedure Step Transaction UID',
  '00404025': 'Scheduled Station Name Code Sequence',
  '00404026': 'Scheduled Station Class Code Sequence',
  '00404027': 'Scheduled Station Geographic Location Code Sequence',
  '00404028': 'Performed Station Name Code Sequence',
  '00404029': 'Performed Station Class Code Sequence',
  '00404030': 'Performed Station Geographic Location Code Sequence',
  '00404031': 'Requested Subsequent Workitem Code Sequence',
  '00404032': 'Non-DICOM Output Code Sequence',
  '00404033': 'Output Information Sequence',
  '00404034': 'Scheduled Human Performers Sequence',
  '00404035': 'Actual Human Performers Sequence',
  '00404036': 'Human Performers Organization',
  '00404037': 'Human Performers Name',
  '00404040': 'Raw Data Handling',
  '00404041': 'Input Readiness State',
  '00404050': 'Performed Procedure Step Start DateTime',
  '00404051': 'Performed Procedure Step End DateTime',
  '00404052': 'Procedure Step Cancellation DateTime',
  '00408302': 'Entrance Dose in m​Gy',
  '00409094': 'Referenced Image Real World Value Mapping Sequence',
  '00409096': 'Real World Value Mapping Sequence',
  '00409098': 'Pixel Value Mapping Code Sequence',
  '00409210': 'LUT Label',
  '00409211': 'Real World Value Last Value Mapped',
  '00409212': 'Real World Value LUT Data',
  '00409216': 'Real World Value First Value Mapped',
  '00409224': 'Real World Value Intercept',
  '00409225': 'Real World Value Slope',
  '0040A007': 'Findings Flag (Trial)',
  '0040A010': 'Relationship Type',
  '0040A020': 'Findings Sequence (Trial)',
  '0040A021': 'Findings Group UID (Trial)',
  '0040A022': 'Referenced Findings Group UID (Trial)',
  '0040A023': 'Findings Group Recording Date (Trial)',
  '0040A024': 'Findings Group Recording Time (Trial)',
  '0040A026': 'Findings Source Category Code Sequence (Trial)',
  '0040A027': 'Verifying Organization',
  '0040A028': 'Documenting Organization Identifier Code Sequence (Trial)',
  '0040A030': 'Verification DateTime',
  '0040A032': 'Observation DateTime',
  '0040A040': 'Value Type',
  '0040A043': 'Concept Name Code Sequence',
  '0040A047': 'Measurement Precision Description (Trial)',
  '0040A050': 'Continuity Of Content',
  '0040A057': 'Urgency or Priority Alerts (Trial)',
  '0040A060': 'Sequencing Indicator (Trial)',
  '0040A066': 'Document Identifier Code Sequence (Trial)',
  '0040A067': 'Document Author (Trial)',
  '0040A068': 'Document Author Identifier Code Sequence (Trial)',
  '0040A070': 'Identifier Code Sequence (Trial)',
  '0040A073': 'Verifying Observer Sequence',
  '0040A074': 'Object Binary Identifier (Trial)',
  '0040A075': 'Verifying Observer Name',
  '0040A076': 'Documenting Observer Identifier Code Sequence (Trial)',
  '0040A078': 'Author Observer Sequence',
  '0040A07A': 'Participant Sequence',
  '0040A07C': 'Custodial Organization Sequence',
  '0040A080': 'Participation Type',
  '0040A082': 'Participation DateTime',
  '0040A084': 'Observer Type',
  '0040A085': 'Procedure Identifier Code Sequence (Trial)',
  '0040A088': 'Verifying Observer Identification Code Sequence',
  '0040A089': 'Object Directory Binary Identifier (Trial)',
  '0040A090': 'Equivalent CDA Document Sequence',
  '0040A0B0': 'Referenced Waveform Channels',
  '0040A110': 'Date of Document or Verbal Transaction (Trial)',
  '0040A112': 'Time of Document Creation or Verbal Transaction (Trial)',
  '0040A120': 'Date​Time',
  '0040A121': 'Date',
  '0040A122': 'Time',
  '0040A123': 'Person Name',
  '0040A124': 'UID',
  '0040A125': 'Report Status ID (Trial)',
  '0040A130': 'Temporal Range Type',
  '0040A132': 'Referenced Sample Positions',
  '0040A136': 'Referenced Frame Numbers',
  '0040A138': 'Referenced Time Offsets',
  '0040A13A': 'Referenced DateTime',
  '0040A160': 'Text Value',
  '0040A161': 'Floating Point Value',
  '0040A162': 'Rational Numerator Value',
  '0040A163': 'Rational Denominator Value',
  '0040A167': 'Observation Category Code Sequence (Trial)',
  '0040A168': 'Concept Code Sequence',
  '0040A16A': 'Bibliographic Citation (Trial)',
  '0040A170': 'Purpose of Reference Code Sequence',
  '0040A171': 'Observation UID',
  '0040A172': 'Referenced Observation UID (Trial)',
  '0040A173': 'Referenced Observation Class (Trial)',
  '0040A174': 'Referenced Object Observation Class (Trial)',
  '0040A180': 'Annotation Group Number',
  '0040A192': 'Observation Date (Trial)',
  '0040A193': 'Observation Time (Trial)',
  '0040A194': 'Measurement Automation (Trial)',
  '0040A195': 'Modifier Code Sequence',
  '0040A224': 'Identification Description (Trial)',
  '0040A290': 'Coordinates Set Geometric Type (Trial)',
  '0040A296': 'Algorithm Code Sequence (Trial)',
  '0040A297': 'Algorithm Description (Trial)',
  '0040A29A': 'Pixel Coordinates Set (Trial)',
  '0040A300': 'Measured Value Sequence',
  '0040A301': 'Numeric Value Qualifier Code Sequence',
  '0040A307': 'Current Observer (Trial)',
  '0040A30A': 'Numeric Value',
  '0040A313': 'Referenced Accession Sequence (Trial)',
  '0040A33A': 'Report Status Comment (Trial)',
  '0040A340': 'Procedure Context Sequence (Trial)',
  '0040A352': 'Verbal Source (Trial)',
  '0040A353': 'Address (Trial)',
  '0040A354': 'Telephone Number (Trial)',
  '0040A358': 'Verbal Source Identifier Code Sequence (Trial)',
  '0040A360': 'Predecessor Documents Sequence',
  '0040A370': 'Referenced Request Sequence',
  '0040A372': 'Performed Procedure Code Sequence',
  '0040A375': 'Current Requested Procedure Evidence Sequence',
  '0040A380': 'Report Detail Sequence (Trial)',
  '0040A385': 'Pertinent Other Evidence Sequence',
  '0040A390': 'HL7 Structured Document Reference Sequence',
  '0040A402': 'Observation Subject UID (Trial)',
  '0040A403': 'Observation Subject Class (Trial)',
  '0040A404': 'Observation Subject Type Code Sequence (Trial)',
  '0040A491': 'Completion Flag',
  '0040A492': 'Completion Flag Description',
  '0040A493': 'Verification Flag',
  '0040A494': 'Archive Requested',
  '0040A496': 'Preliminary Flag',
  '0040A504': 'Content Template Sequence',
  '0040A525': 'Identical Documents Sequence',
  '0040A600': 'Observation Subject Context Flag (Trial)',
  '0040A601': 'Observer Context Flag (Trial)',
  '0040A603': 'Procedure Context Flag (Trial)',
  '0040A730': 'Content Sequence',
  '0040A731': 'Relationship Sequence (Trial)',
  '0040A732': 'Relationship Type Code Sequence (Trial)',
  '0040A744': 'Language Code Sequence (Trial)',
  '0040A992': 'Uniform Resource Locator (Trial)',
  '0040B020': 'Waveform Annotation Sequence',
  '0040DB00': 'Template Identifier',
  '0040DB06': 'Template Version',
  '0040DB07': 'Template Local Version',
  '0040DB0B': 'Template Extension Flag',
  '0040DB0C': 'Template Extension Organization UID',
  '0040DB0D': 'Template Extension Creator UID',
  '0040DB73': 'Referenced Content Item Identifier',
  '0040E001': 'HL7 Instance Identifier',
  '0040E004': 'HL7 Document Effective Time',
  '0040E006': 'HL7 Document Type Code Sequence',
  '0040E008': 'Document Class Code Sequence',
  '0040E010': 'Retrieve URI',
  '0040E011': 'Retrieve Location UID',
  '0040E020': 'Type of Instances',
  '0040E021': 'DICOM Retrieval Sequence',
  '0040E022': 'DICOM Media Retrieval Sequence',
  '0040E023': 'WADO Retrieval Sequence',
  '0040E024': 'XDS Retrieval Sequence',
  '0040E030': 'Repository Unique ID',
  '0040E031': 'Home Community ID',
  '00420010': 'Document Title',
  '00420011': 'Encapsulated Document',
  '00420012': 'MIME Type of Encapsulated Document',
  '00420013': 'Source Instance Sequence',
  '00420014': 'List of MIME Types',
  '00440001': 'Product Package Identifier',
  '00440002': 'Substance Administration Approval',
  '00440003': 'Approval Status Further Description',
  '00440004': 'Approval Status DateTime',
  '00440007': 'Product Type Code Sequence',
  '00440008': 'Product Name',
  '00440009': 'Product Description',
  '0044000A': 'Product Lot Identifier',
  '0044000B': 'Product Expiration DateTime',
  '00440010': 'Substance Administration DateTime',
  '00440011': 'Substance Administration Notes',
  '00440012': 'Substance Administration Device ID',
  '00440013': 'Product Parameter Sequence',
  '00440019': 'Substance Administration Parameter Sequence',
  '00460012': 'Lens Description',
  '00460014': 'Right Lens Sequence',
  '00460015': 'Left Lens Sequence',
  '00460016': 'Unspecified Laterality Lens Sequence',
  '00460018': 'Cylinder Sequence',
  '00460028': 'Prism Sequence',
  '00460030': 'Horizontal Prism Power',
  '00460032': 'Horizontal Prism Base',
  '00460034': 'Vertical Prism Power',
  '00460036': 'Vertical Prism Base',
  '00460038': 'Lens Segment Type',
  '00460040': 'Optical Transmittance',
  '00460042': 'Channel Width',
  '00460044': 'Pupil Size',
  '00460046': 'Corneal Size',
  '00460050': 'Autorefraction Right Eye Sequence',
  '00460052': 'Autorefraction Left Eye Sequence',
  '00460060': 'Distance Pupillary Distance',
  '00460062': 'Near Pupillary Distance',
  '00460063': 'Intermediate Pupillary Distance',
  '00460064': 'Other Pupillary Distance',
  '00460070': 'Keratometry Right Eye Sequence',
  '00460071': 'Keratometry Left Eye Sequence',
  '00460074': 'Steep Keratometric Axis Sequence',
  '00460075': 'Radius of Curvature',
  '00460076': 'Keratometric Power',
  '00460077': 'Keratometric Axis',
  '00460080': 'Flat Keratometric Axis Sequence',
  '00460092': 'Background Color',
  '00460094': 'Optotype',
  '00460095': 'Optotype Presentation',
  '00460097': 'Subjective Refraction Right Eye Sequence',
  '00460098': 'Subjective Refraction Left Eye Sequence',
  '00460100': 'Add Near Sequence',
  '00460101': 'Add Intermediate Sequence',
  '00460102': 'Add Other Sequence',
  '00460104': 'Add Power',
  '00460106': 'Viewing Distance',
  '00460121': 'Visual Acuity Type Code Sequence',
  '00460122': 'Visual Acuity Right Eye Sequence',
  '00460123': 'Visual Acuity Left Eye Sequence',
  '00460124': 'Visual Acuity Both Eyes Open Sequence',
  '00460125': 'Viewing Distance Type',
  '00460135': 'Visual Acuity Modifiers',
  '00460137': 'Decimal Visual Acuity',
  '00460139': 'Optotype Detailed Definition',
  '00460145': 'Referenced Refractive Measurements Sequence',
  '00460146': 'Sphere Power',
  '00460147': 'Cylinder Power',
  '00460201': 'Corneal Topography Surface',
  '00460202': 'Corneal Vertex Location',
  '00460203': 'Pupil Centroid X-Coordinate',
  '00460204': 'Pupil Centroid Y-Coordinate',
  '00460205': 'Equivalent Pupil Radius',
  '00460207': 'Corneal Topography Map Type Code Sequence',
  '00460208': 'Vertices of the Outline of Pupil',
  '00460210': 'Corneal Topography Mapping Normals Sequence',
  '00460211': 'Maximum Corneal Curvature Sequence',
  '00460212': 'Maximum Corneal Curvature',
  '00460213': 'Maximum Corneal Curvature Location',
  '00460215': 'Minimum Keratometric Sequence',
  '00460218': 'Simulated Keratometric Cylinder Sequence',
  '00460220': 'Average Corneal Power',
  '00460224': 'Corneal I-S Value',
  '00460227': 'Analyzed Area',
  '00460230': 'Surface Regularity Index',
  '00460232': 'Surface Asymmetry Index',
  '00460234': 'Corneal Eccentricity Index',
  '00460236': 'Keratoconus Prediction Index',
  '00460238': 'Decimal Potential Visual Acuity',
  '00460242': 'Corneal Topography Map Quality Evaluation',
  '00460244': 'Source Image Corneal Processed Data Sequence',
  '00460247': 'Corneal Point Location',
  '00460248': 'Corneal Point Estimated',
  '00460249': 'Axial Power',
  '00460250': 'Tangential Power',
  '00460251': 'Refractive Power',
  '00460252': 'Relative Elevation',
  '00460253': 'Corneal Wavefront',
  '00480001': 'Imaged Volume Width',
  '00480002': 'Imaged Volume Height',
  '00480003': 'Imaged Volume Depth',
  '00480006': 'Total Pixel Matrix Columns',
  '00480007': 'Total Pixel Matrix Rows',
  '00480008': 'Total Pixel Matrix Origin Sequence',
  '00480010': 'Specimen Label in Image',
  '00480011': 'Focus Method',
  '00480012': 'Extended Depth of Field',
  '00480013': 'Number of Focal Planes',
  '00480014': 'Distance Between Focal Planes',
  '00480015': 'Recommended Absent Pixel CIE​Lab Value',
  '00480100': 'Illuminator Type Code Sequence',
  '00480102': 'Image Orientation (Slide)',
  '00480105': 'Optical Path Sequence',
  '00480106': 'Optical Path Identifier',
  '00480107': 'Optical Path Description',
  '00480108': 'Illumination Color Code Sequence',
  '00480110': 'Specimen Reference Sequence',
  '00480111': 'Condenser Lens Power',
  '00480112': 'Objective Lens Power',
  '00480113': 'Objective Lens Numerical Aperture',
  '00480120': 'Palette Color Lookup Table Sequence',
  '00480200': 'Referenced Image Navigation Sequence',
  '00480201': 'Top Left Hand Corner of Localizer Area',
  '00480202': 'Bottom Right Hand Corner of Localizer Area',
  '00480207': 'Optical Path Identification Sequence',
  '0048021A': 'Plane Position (Slide) Sequence',
  '0048021E': 'Column Position In Total Image Pixel Matrix',
  '0048021F': 'Row Position In Total Image Pixel Matrix',
  '00480301': 'Pixel Origin Interpretation',
  '00500004': 'Calibration Image',
  '00500010': 'Device Sequence',
  '00500012': 'Container Component Type Code Sequence',
  '00500013': 'Container Component Thickness',
  '00500014': 'Device Length',
  '00500015': 'Container Component Width',
  '00500016': 'Device Diameter',
  '00500017': 'Device Diameter Units',
  '00500018': 'Device Volume',
  '00500019': 'Inter-Marker Distance',
  '0050001A': 'Container Component Material',
  '0050001B': 'Container Component ID',
  '0050001C': 'Container Component Length',
  '0050001D': 'Container Component Diameter',
  '0050001E': 'Container Component Description',
  '00500020': 'Device Description',
  '00520001': 'Contrast/Bolus Ingredient Percent by Volume',
  '00520002': 'OCT Focal Distance',
  '00520003': 'Beam Spot Size',
  '00520004': 'Effective Refractive Index',
  '00520006': 'OCT Acquisition Domain',
  '00520007': 'OCT Optical Center Wavelength',
  '00520008': 'Axial Resolution',
  '00520009': 'Ranging Depth',
  '00520011': 'A-line Rate',
  '00520012': 'A-lines Per Frame',
  '00520013': 'Catheter Rotational Rate',
  '00520014': 'A-line Pixel Spacing',
  '00520016': 'Mode of Percutaneous Access Sequence',
  '00520025': 'Intravascular OCT Frame Type Sequence',
  '00520026': 'OCT Z Offset Applied',
  '00520027': 'Intravascular Frame Content Sequence',
  '00520028': 'Intravascular Longitudinal Distance',
  '00520029': 'Intravascular OCT Frame Content Sequence',
  '00520030': 'OCT Z Offset Correction',
  '00520031': 'Catheter Direction of Rotation',
  '00520033': 'Seam Line Location',
  '00520034': 'First A-line Location',
  '00520036': 'Seam Line Index',
  '00520038': 'Number of Padded A-lines',
  '00520039': 'Interpolation Type',
  '0052003A': 'Refractive Index Applied',
  '00540010': 'Energy Window Vector',
  '00540011': 'Number of Energy Windows',
  '00540012': 'Energy Window Information Sequence',
  '00540013': 'Energy Window Range Sequence',
  '00540014': 'Energy Window Lower Limit',
  '00540015': 'Energy Window Upper Limit',
  '00540016': 'Radio​pharmaceutical Information Sequence',
  '00540017': 'Residual Syringe Counts',
  '00540018': 'Energy Window Name',
  '00540020': 'Detector Vector',
  '00540021': 'Number of Detectors',
  '00540022': 'Detector Information Sequence',
  '00540030': 'Phase Vector',
  '00540031': 'Number of Phases',
  '00540032': 'Phase Information Sequence',
  '00540033': 'Number of Frames in Phase',
  '00540036': 'Phase Delay',
  '00540038': 'Pause Between Frames',
  '00540039': 'Phase Description',
  '00540050': 'Rotation Vector',
  '00540051': 'Number of Rotations',
  '00540052': 'Rotation Information Sequence',
  '00540053': 'Number of Frames in Rotation',
  '00540060': 'R-R Interval Vector',
  '00540061': 'Number of R-R Intervals',
  '00540062': 'Gated Information Sequence',
  '00540063': 'Data Information Sequence',
  '00540070': 'Time Slot Vector',
  '00540071': 'Number of Time Slots',
  '00540072': 'Time Slot Information Sequence',
  '00540073': 'Time Slot Time',
  '00540080': 'Slice Vector',
  '00540081': 'Number of Slices',
  '00540090': 'Angular View Vector',
  '00540100': 'Time Slice Vector',
  '00540101': 'Number of Time Slices',
  '00540200': 'Start Angle',
  '00540202': 'Type of Detector Motion',
  '00540210': 'Trigger Vector',
  '00540211': 'Number of Triggers in Phase',
  '00540220': 'View Code Sequence',
  '00540222': 'View Modifier Code Sequence',
  '00540300': 'Radionuclide Code Sequence',
  '00540302': 'Administration Route Code Sequence',
  '00540304': 'Radio​pharmaceutical Code Sequence',
  '00540306': 'Calibration Data Sequence',
  '00540308': 'Energy Window Number',
  '00540400': 'Image ID',
  '00540410': 'Patient Orientation Code Sequence',
  '00540412': 'Patient Orientation Modifier Code Sequence',
  '00540414': 'Patient Gantry Relationship Code Sequence',
  '00540500': 'Slice Progression Direction',
  '00541000': 'Series Type',
  '00541001': 'Units',
  '00541002': 'Counts Source',
  '00541004': 'Reprojection Method',
  '00541006': 'SUV Type',
  '00541100': 'Randoms Correction Method',
  '00541101': 'Attenuation Correction Method',
  '00541102': 'Decay Correction',
  '00541103': 'Reconstruction Method',
  '00541104': 'Detector Lines of Response Used',
  '00541105': 'Scatter Correction Method',
  '00541200': 'Axial Acceptance',
  '00541201': 'Axial Mash',
  '00541202': 'Transverse Mash',
  '00541203': 'Detector Element Size',
  '00541210': 'Coincidence Window Width',
  '00541220': 'Secondary Counts Type',
  '00541300': 'Frame Reference Time',
  '00541310': 'Primary (Prompts) Counts Accumulated',
  '00541311': 'Secondary Counts Accumulated',
  '00541320': 'Slice Sensitivity Factor',
  '00541321': 'Decay Factor',
  '00541322': 'Dose Calibration Factor',
  '00541323': 'Scatter Fraction Factor',
  '00541324': 'Dead Time Factor',
  '00541330': 'Image Index',
  '00541400': 'Counts Included',
  '00541401': 'Dead Time Correction Flag',
  '00603000': 'Histogram Sequence',
  '00603002': 'Histogram Number of Bins',
  '00603004': 'Histogram First Bin Value',
  '00603006': 'Histogram Last Bin Value',
  '00603008': 'Histogram Bin Width',
  '00603010': 'Histogram Explanation',
  '00603020': 'Histogram Data',
  '00620001': 'Segmentation Type',
  '00620002': 'Segment Sequence',
  '00620003': 'Segmented Property Category Code Sequence',
  '00620004': 'Segment Number',
  '00620005': 'Segment Label',
  '00620006': 'Segment Description',
  '00620008': 'Segment Algorithm Type',
  '00620009': 'Segment Algorithm Name',
  '0062000A': 'Segment Identification Sequence',
  '0062000B': 'Referenced Segment Number',
  '0062000C': 'Recommended Display Grayscale Value',
  '0062000D': 'Recommended Display CIE​Lab Value',
  '0062000E': 'Maximum Fractional Value',
  '0062000F': 'Segmented Property Type Code Sequence',
  '00620010': 'Segmentation Fractional Type',
  '00620011': 'Segmented Property Type Modifier Code Sequence',
  '00620012': 'Used Segments Sequence',
  '00640002': 'Deformable Registration Sequence',
  '00640003': 'Source Frame of Reference UID',
  '00640005': 'Deformable Registration Grid Sequence',
  '00640007': 'Grid Dimensions',
  '00640008': 'Grid Resolution',
  '00640009': 'Vector Grid Data',
  '0064000F': 'Pre Deformation Matrix Registration Sequence',
  '00640010': 'Post Deformation Matrix Registration Sequence',
  '00660001': 'Number of Surfaces',
  '00660002': 'Surface Sequence',
  '00660003': 'Surface Number',
  '00660004': 'Surface Comments',
  '00660009': 'Surface Processing',
  '0066000A': 'Surface Processing Ratio',
  '0066000B': 'Surface Processing Description',
  '0066000C': 'Recommended Presentation Opacity',
  '0066000D': 'Recommended Presentation Type',
  '0066000E': 'Finite Volume',
  '00660010': 'Manifold',
  '00660011': 'Surface Points Sequence',
  '00660012': 'Surface Points Normals Sequence',
  '00660013': 'Surface Mesh Primitives Sequence',
  '00660015': 'Number of Surface Points',
  '00660016': 'Point Coordinates Data',
  '00660017': 'Point Position Accuracy',
  '00660018': 'Mean Point Distance',
  '00660019': 'Maximum Point Distance',
  '0066001A': 'Points Bounding Box Coordinates',
  '0066001B': 'Axis of Rotation',
  '0066001C': 'Center of Rotation',
  '0066001E': 'Number of Vectors',
  '0066001F': 'Vector Dimensionality',
  '00660020': 'Vector Accuracy',
  '00660021': 'Vector Coordinate Data',
  '00660023': 'Triangle Point Index List',
  '00660024': 'Edge Point Index List',
  '00660025': 'Vertex Point Index List',
  '00660026': 'Triangle Strip Sequence',
  '00660027': 'Triangle Fan Sequence',
  '00660028': 'Line Sequence',
  '00660029': 'Primitive Point Index List',
  '0066002A': 'Surface Count',
  '0066002B': 'Referenced Surface Sequence',
  '0066002C': 'Referenced Surface Number',
  '0066002D': 'Segment Surface Generation Algorithm Identification Sequence',
  '0066002E': 'Segment Surface Source Instance Sequence',
  '0066002F': 'Algorithm Family Code Sequence',
  '00660030': 'Algorithm Name Code Sequence',
  '00660031': 'Algorithm Version',
  '00660032': 'Algorithm Parameters',
  '00660034': 'Facet Sequence',
  '00660035': 'Surface Processing Algorithm Identification Sequence',
  '00660036': 'Algorithm Name',
  '00660037': 'Recommended Point Radius',
  '00660038': 'Recommended Line Thickness',
  '00686210': 'Implant Size',
  '00686221': 'Implant Template Version',
  '00686222': 'Replaced Implant Template Sequence',
  '00686223': 'Implant Type',
  '00686224': 'Derivation Implant Template Sequence',
  '00686225': 'Original Implant Template Sequence',
  '00686226': 'Effective DateTime',
  '00686230': 'Implant Target Anatomy Sequence',
  '00686260': 'Information From Manufacturer Sequence',
  '00686265': 'Notification From Manufacturer Sequence',
  '00686270': 'Information Issue DateTime',
  '00686280': 'Information Summary',
  '006862A0': 'Implant Regulatory Disapproval Code Sequence',
  '006862A5': 'Overall Template Spatial Tolerance',
  '006862C0': 'HPGL Document Sequence',
  '006862D0': 'HPGL Document ID',
  '006862D5': 'HPGL Document Label',
  '006862E0': 'View Orientation Code Sequence',
  '006862F0': 'View Orientation Modifier',
  '006862F2': 'HPGL Document Scaling',
  '00686300': 'HPGL Document',
  '00686310': 'HPGL Contour Pen Number',
  '00686320': 'HPGL Pen Sequence',
  '00686330': 'HPGL Pen Number',
  '00686340': 'HPGL Pen Label',
  '00686345': 'HPGL Pen Description',
  '00686346': 'Recommended Rotation Point',
  '00686347': 'Bounding Rectangle',
  '00686350': 'Implant Template 3D Model Surface Number',
  '00686360': 'Surface Model Description Sequence',
  '00686380': 'Surface Model Label',
  '00686390': 'Surface Model Scaling Factor',
  '006863A0': 'Materials Code Sequence',
  '006863A4': 'Coating Materials Code Sequence',
  '006863A8': 'Implant Type Code Sequence',
  '006863AC': 'Fixation Method Code Sequence',
  '006863B0': 'Mating Feature Sets Sequence',
  '006863C0': 'Mating Feature Set ID',
  '006863D0': 'Mating Feature Set Label',
  '006863E0': 'Mating Feature Sequence',
  '006863F0': 'Mating Feature ID',
  '00686400': 'Mating Feature Degree of Freedom Sequence',
  '00686410': 'Degree of Freedom ID',
  '00686420': 'Degree of Freedom Type',
  '00686430': '2D Mating Feature Coordinates Sequence',
  '00686440': 'Referenced HPGL Document ID',
  '00686450': '2D Mating Point',
  '00686460': '2D Mating Axes',
  '00686470': '2D Degree of Freedom Sequence',
  '00686490': '3D Degree of Freedom Axis',
  '006864A0': 'Range of Freedom',
  '006864C0': '3D Mating Point',
  '006864D0': '3D Mating Axes',
  '006864F0': '2D Degree of Freedom Axis',
  '00686500': 'Planning Landmark Point Sequence',
  '00686510': 'Planning Landmark Line Sequence',
  '00686520': 'Planning Landmark Plane Sequence',
  '00686530': 'Planning Landmark ID',
  '00686540': 'Planning Landmark Description',
  '00686545': 'Planning Landmark Identification Code Sequence',
  '00686550': '2D Point Coordinates Sequence',
  '00686560': '2D Point Coordinates',
  '00686590': '3D Point Coordinates',
  '006865A0': '2D Line Coordinates Sequence',
  '006865B0': '2D Line Coordinates',
  '006865D0': '3D Line Coordinates',
  '006865E0': '2D Plane Coordinates Sequence',
  '006865F0': '2D Plane Intersection',
  '00686610': '3D Plane Origin',
  '00686620': '3D Plane Normal',
  '00700001': 'Graphic Annotation Sequence',
  '00700002': 'Graphic Layer',
  '00700003': 'Bounding Box Annotation Units',
  '00700004': 'Anchor Point Annotation Units',
  '00700005': 'Graphic Annotation Units',
  '00700006': 'Unformatted Text Value',
  '00700008': 'Text Object Sequence',
  '00700009': 'Graphic Object Sequence',
  '00700010': 'Bounding Box Top Left Hand Corner',
  '00700011': 'Bounding Box Bottom Right Hand Corner',
  '00700012': 'Bounding Box Text Horizontal Justification',
  '00700014': 'Anchor Point',
  '00700015': 'Anchor Point Visibility',
  '00700020': 'Graphic Dimensions',
  '00700021': 'Number of Graphic Points',
  '00700022': 'Graphic Data',
  '00700023': 'Graphic Type',
  '00700024': 'Graphic Filled',
  '00700040': 'Image Rotation (Retired)',
  '00700041': 'Image Horizontal Flip',
  '00700042': 'Image Rotation',
  '00700050': 'Displayed Area Top Left Hand Corner (Trial)',
  '00700051': 'Displayed Area Bottom Right Hand Corner (Trial)',
  '00700052': 'Displayed Area Top Left Hand Corner',
  '00700053': 'Displayed Area Bottom Right Hand Corner',
  '0070005A': 'Displayed Area Selection Sequence',
  '00700060': 'Graphic Layer Sequence',
  '00700062': 'Graphic Layer Order',
  '00700066': 'Graphic Layer Recommended Display Grayscale Value',
  '00700067': 'Graphic Layer Recommended Display RGB Value',
  '00700068': 'Graphic Layer Description',
  '00700080': 'Content Label',
  '00700081': 'Content Description',
  '00700082': 'Presentation Creation Date',
  '00700083': 'Presentation Creation Time',
  '00700084': 'Content Creators Name',
  '00700086': 'Content Creators Identification Code Sequence',
  '00700087': 'Alternate Content Description Sequence',
  '00700100': 'Presentation Size Mode',
  '00700101': 'Presentation Pixel Spacing',
  '00700102': 'Presentation Pixel Aspect Ratio',
  '00700103': 'Presentation Pixel Magnification Ratio',
  '00700207': 'Graphic Group Label',
  '00700208': 'Graphic Group Description',
  '00700209': 'Compound Graphic Sequence',
  '00700226': 'Compound Graphic Instance ID',
  '00700227': 'Font Name',
  '00700228': 'Font Name Type',
  '00700229': 'CSS Font Name',
  '00700230': 'Rotation Angle',
  '00700231': 'Text Style Sequence',
  '00700232': 'Line Style Sequence',
  '00700233': 'Fill Style Sequence',
  '00700234': 'Graphic Group Sequence',
  '00700241': 'Text Color CIE​Lab Value',
  '00700242': 'Horizontal Alignment',
  '00700243': 'Vertical Alignment',
  '00700244': 'Shadow Style',
  '00700245': 'Shadow Offset X',
  '00700246': 'Shadow Offset Y',
  '00700247': 'Shadow Color CIE​Lab Value',
  '00700248': 'Underlined',
  '00700249': 'Bold',
  '00700250': 'Italic',
  '00700251': 'Pattern On Color CIE​Lab Value',
  '00700252': 'Pattern Off Color CIE​Lab Value',
  '00700253': 'Line Thickness',
  '00700254': 'Line Dashing Style',
  '00700255': 'Line Pattern',
  '00700256': 'Fill Pattern',
  '00700257': 'Fill Mode',
  '00700258': 'Shadow Opacity',
  '00700261': 'Gap Length',
  '00700262': 'Diameter of Visibility',
  '00700273': 'Rotation Point',
  '00700274': 'Tick Alignment',
  '00700278': 'Show Tick Label',
  '00700279': 'Tick Label Alignment',
  '00700282': 'Compound Graphic Units',
  '00700284': 'Pattern On Opacity',
  '00700285': 'Pattern Off Opacity',
  '00700287': 'Major Ticks Sequence',
  '00700288': 'Tick Position',
  '00700289': 'Tick Label',
  '00700294': 'Compound Graphic Type',
  '00700295': 'Graphic Group ID',
  '00700306': 'Shape Type',
  '00700308': 'Registration Sequence',
  '00700309': 'Matrix Registration Sequence',
  '0070030A': 'Matrix Sequence',
  '0070030C': 'Frame of Reference Transformation Matrix Type',
  '0070030D': 'Registration Type Code Sequence',
  '0070030F': 'Fiducial Description',
  '00700310': 'Fiducial Identifier',
  '00700311': 'Fiducial Identifier Code Sequence',
  '00700312': 'Contour Uncertainty Radius',
  '00700314': 'Used Fiducials Sequence',
  '00700318': 'Graphic Coordinates Data Sequence',
  '0070031A': 'Fiducial UID',
  '0070031C': 'Fiducial Set Sequence',
  '0070031E': 'Fiducial Sequence',
  '00700401': 'Graphic Layer Recommended Display CIE​Lab Value',
  '00700402': 'Blending Sequence',
  '00700403': 'Relative Opacity',
  '00700404': 'Referenced Spatial Registration Sequence',
  '00700405': 'Blending Position',
  '00720002': 'Hanging Protocol Name',
  '00720004': 'Hanging Protocol Description',
  '00720006': 'Hanging Protocol Level',
  '00720008': 'Hanging Protocol Creator',
  '0072000A': 'Hanging Protocol Creation DateTime',
  '0072000C': 'Hanging Protocol Definition Sequence',
  '0072000E': 'Hanging Protocol User Identification Code Sequence',
  '00720010': 'Hanging Protocol User Group Name',
  '00720012': 'Source Hanging Protocol Sequence',
  '00720014': 'Number of Priors Referenced',
  '00720020': 'Image Sets Sequence',
  '00720022': 'Image Set Selector Sequence',
  '00720024': 'Image Set Selector Usage Flag',
  '00720026': 'Selector Attribute',
  '00720028': 'Selector Value Number',
  '00720030': 'Time Based Image Sets Sequence',
  '00720032': 'Image Set Number',
  '00720034': 'Image Set Selector Category',
  '00720038': 'Relative Time',
  '0072003A': 'Relative Time Units',
  '0072003C': 'Abstract Prior Value',
  '0072003E': 'Abstract Prior Code Sequence',
  '00720040': 'Image Set Label',
  '00720050': 'Selector Attribute VR',
  '00720052': 'Selector Sequence Pointer',
  '00720054': 'Selector Sequence Pointer Private Creator',
  '00720056': 'Selector Attribute Private Creator',
  '00720060': 'Selector AT Value',
  '00720062': 'Selector CS Value',
  '00720064': 'Selector IS Value',
  '00720066': 'Selector LO Value',
  '00720068': 'Selector LT Value',
  '0072006A': 'Selector PN Value',
  '0072006C': 'Selector SH Value',
  '0072006E': 'Selector ST Value',
  '00720070': 'Selector UT Value',
  '00720072': 'Selector DS Value',
  '00720074': 'Selector FD Value',
  '00720076': 'Selector FL Value',
  '00720078': 'Selector UL Value',
  '0072007A': 'Selector US Value',
  '0072007C': 'Selector SL Value',
  '0072007E': 'Selector SS Value',
  '00720080': 'Selector Code Sequence Value',
  '00720100': 'Number of Screens',
  '00720102': 'Nominal Screen Definition Sequence',
  '00720104': 'Number of Vertical Pixels',
  '00720106': 'Number of Horizontal Pixels',
  '00720108': 'Display Environment Spatial Position',
  '0072010A': 'Screen Minimum Grayscale Bit Depth',
  '0072010C': 'Screen Minimum Color Bit Depth',
  '0072010E': 'Application Maximum Repaint Time',
  '00720200': 'Display Sets Sequence',
  '00720202': 'Display Set Number',
  '00720203': 'Display Set Label',
  '00720204': 'Display Set Presentation Group',
  '00720206': 'Display Set Presentation Group Description',
  '00720208': 'Partial Data Display Handling',
  '00720210': 'Synchronized Scrolling Sequence',
  '00720212': 'Display Set Scrolling Group',
  '00720214': 'Navigation Indicator Sequence',
  '00720216': 'Navigation Display Set',
  '00720218': 'Reference Display Sets',
  '00720300': 'Image Boxes Sequence',
  '00720302': 'Image Box Number',
  '00720304': 'Image Box Layout Type',
  '00720306': 'Image Box Tile Horizontal Dimension',
  '00720308': 'Image Box Tile Vertical Dimension',
  '00720310': 'Image Box Scroll Direction',
  '00720312': 'Image Box Small Scroll Type',
  '00720314': 'Image Box Small Scroll Amount',
  '00720316': 'Image Box Large Scroll Type',
  '00720318': 'Image Box Large Scroll Amount',
  '00720320': 'Image Box Overlap Priority',
  '00720330': 'Cine Relative to Real-Time',
  '00720400': 'Filter Operations Sequence',
  '00720402': 'Filter-by Category',
  '00720404': 'Filter-by Attribute Presence',
  '00720406': 'Filter-by Operator',
  '00720420': 'Structured Display Background CIE​Lab Value',
  '00720421': 'Empty Image Box CIE​Lab Value',
  '00720422': 'Structured Display Image Box Sequence',
  '00720424': 'Structured Display Text Box Sequence',
  '00720427': 'Referenced First Frame Sequence',
  '00720430': 'Image Box Synchronization Sequence',
  '00720432': 'Synchronized Image Box List',
  '00720434': 'Type of Synchronization',
  '00720500': 'Blending Operation Type',
  '00720510': 'Reformatting Operation Type',
  '00720512': 'Reformatting Thickness',
  '00720514': 'Reformatting Interval',
  '00720516': 'Reformatting Operation Initial View Direction',
  '00720520': '3D Rendering Type',
  '00720600': 'Sorting Operations Sequence',
  '00720602': 'Sort-by Category',
  '00720604': 'Sorting Direction',
  '00720700': 'Display Set Patient Orientation',
  '00720702': 'VOI Type',
  '00720704': 'Pseudo-Color Type',
  '00720705': 'Pseudo-Color Palette Instance Reference Sequence',
  '00720706': 'Show Grayscale Inverted',
  '00720710': 'Show Image True Size Flag',
  '00720712': 'Show Graphic Annotation Flag',
  '00720714': 'Show Patient Demographics Flag',
  '00720716': 'Show Acquisition Techniques Flag',
  '00720717': 'Display Set Horizontal Justification',
  '00720718': 'Display Set Vertical Justification',
  '00740120': 'Continuation Start Meterset',
  '00740121': 'Continuation End Meterset',
  '00741000': 'Procedure Step State',
  '00741002': 'Procedure Step Progress Information Sequence',
  '00741004': 'Procedure Step Progress',
  '00741006': 'Procedure Step Progress Description',
  '00741008': 'Procedure Step Communications URI Sequence',
  '0074100a': 'Contact URI',
  '0074100c': 'Contact Display Name',
  '0074100e': 'Procedure Step Discontinuation Reason Code Sequence',
  '00741020': 'Beam Task Sequence',
  '00741022': 'Beam Task Type',
  '00741024': 'Beam Order Index (Trial)',
  '00741025': 'Autosequence Flag',
  '00741026': 'Table Top Vertical Adjusted Position',
  '00741027': 'Table Top Longitudinal Adjusted Position',
  '00741028': 'Table Top Lateral Adjusted Position',
  '0074102A': 'Patient Support Adjusted Angle',
  '0074102B': 'Table Top Eccentric Adjusted Angle',
  '0074102C': 'Table Top Pitch Adjusted Angle',
  '0074102D': 'Table Top Roll Adjusted Angle',
  '00741030': 'Delivery Verification Image Sequence',
  '00741032': 'Verification Image Timing',
  '00741034': 'Double Exposure Flag',
  '00741036': 'Double Exposure Ordering',
  '00741038': 'Double Exposure Meterset (Trial)',
  '0074103A': 'Double Exposure Field Delta (Trial)',
  '00741040': 'Related Reference RT Image Sequence',
  '00741042': 'General Machine Verification Sequence',
  '00741044': 'Conventional Machine Verification Sequence',
  '00741046': 'Ion Machine Verification Sequence',
  '00741048': 'Failed Attributes Sequence',
  '0074104A': 'Overridden Attributes Sequence',
  '0074104C': 'Conventional Control Point Verification Sequence',
  '0074104E': 'Ion Control Point Verification Sequence',
  '00741050': 'Attribute Occurrence Sequence',
  '00741052': 'Attribute Occurrence Pointer',
  '00741054': 'Attribute Item Selector',
  '00741056': 'Attribute Occurrence Private Creator',
  '00741057': 'Selector Sequence Pointer Items',
  '00741200': 'Scheduled Procedure Step Priority',
  '00741202': 'Worklist Label',
  '00741204': 'Procedure Step Label',
  '00741210': 'Scheduled Processing Parameters Sequence',
  '00741212': 'Performed Processing Parameters Sequence',
  '00741216': 'Unified Procedure Step Performed Procedure Sequence',
  '00741220': 'Related Procedure Step Sequence',
  '00741222': 'Procedure Step Relationship Type',
  '00741224': 'Replaced Procedure Step Sequence',
  '00741230': 'Deletion Lock',
  '00741234': 'Receiving AE',
  '00741236': 'Requesting AE',
  '00741238': 'Reason for Cancellation',
  '00741242': 'SCP Status',
  '00741244': 'Subscription List Status',
  '00741246': 'Unified Procedure Step​List Status',
  '00741324': 'Beam Order Index',
  '00741338': 'Double Exposure Meterset',
  '0074133A': 'Double Exposure Field Delta',
  '00760001': 'Implant Assembly Template Name',
  '00760003': 'Implant Assembly Template Issuer',
  '00760006': 'Implant Assembly Template Version',
  '00760008': 'Replaced Implant Assembly Template Sequence',
  '0076000A': 'Implant Assembly Template Type',
  '0076000C': 'Original Implant Assembly Template Sequence',
  '0076000E': 'Derivation Implant Assembly Template Sequence',
  '00760010': 'Implant Assembly Template Target Anatomy Sequence',
  '00760020': 'Procedure Type Code Sequence',
  '00760030': 'Surgical Technique',
  '00760032': 'Component Types Sequence',
  '00760034': 'Component Type Code Sequence',
  '00760036': 'Exclusive Component Type',
  '00760038': 'Mandatory Component Type',
  '00760040': 'Component Sequence',
  '00760055': 'Component ID',
  '00760060': 'Component Assembly Sequence',
  '00760070': 'Component 1 Referenced ID',
  '00760080': 'Component 1 Referenced Mating Feature Set ID',
  '00760090': 'Component 1 Referenced Mating Feature ID',
  '007600A0': 'Component 2 Referenced ID',
  '007600B0': 'Component 2 Referenced Mating Feature Set ID',
  '007600C0': 'Component 2 Referenced Mating Feature ID',
  '00780001': 'Implant Template Group Name',
  '00780010': 'Implant Template Group Description',
  '00780020': 'Implant Template Group Issuer',
  '00780024': 'Implant Template Group Version',
  '00780026': 'Replaced Implant Template Group Sequence',
  '00780028': 'Implant Template Group Target Anatomy Sequence',
  '0078002A': 'Implant Template Group Members Sequence',
  '0078002E': 'Implant Template Group Member ID',
  '00780050': '3D Implant Template Group Member Matching Point',
  '00780060': '3D Implant Template Group Member Matching Axes',
  '00780070': 'Implant Template Group Member Matching 2D Coordinates Sequence',
  '00780090': '2D Implant Template Group Member Matching Point',
  '007800A0': '2D Implant Template Group Member Matching Axes',
  '007800B0': 'Implant Template Group Variation Dimension Sequence',
  '007800B2': 'Implant Template Group Variation Dimension Name',
  '007800B4': 'Implant Template Group Variation Dimension Rank Sequence',
  '007800B6': 'Referenced Implant Template Group Member ID',
  '007800B8': 'Implant Template Group Variation Dimension Rank',
  '00800001': 'Surface Scan Acquisition Type Code Sequence',
  '00800002': 'Surface Scan Mode Code Sequence',
  '00800003': 'Registration Method Code Sequence',
  '00800004': 'Shot Duration Time',
  '00800005': 'Shot Offset Time',
  '00800006': 'Surface Point Presentation Value Data',
  '00800007': 'Surface Point Color CIE​Lab Value Data',
  '00800008': 'UV Mapping Sequence',
  '00800009': 'Texture Label',
  '00800010': 'U Value Data',
  '00800011': 'V Value Data',
  '00800012': 'Referenced Texture Sequence',
  '00800013': 'Referenced Surface Data Sequence',
  '00880130': 'Storage Media File-set ID',
  '00880140': 'Storage Media File-set UID',
  '00880200': 'Icon Image Sequence',
  '00880904': 'Topic Title',
  '00880906': 'Topic Subject',
  '00880910': 'Topic Author',
  '00880912': 'Topic Keywords',
  '01000410': 'SOP Instance Status',
  '01000420': 'SOP Authorization DateTime',
  '01000424': 'SOP Authorization Comment',
  '01000426': 'Authorization Equipment Certification Number',
  '04000005': 'MAC ID Number',
  '04000010': 'MAC Calculation Transfer Syntax UID',
  '04000015': 'MAC Algorithm',
  '04000020': 'Data Elements Signed',
  '04000100': 'Digital Signature UID',
  '04000105': 'Digital Signature DateTime',
  '04000110': 'Certificate Type',
  '04000115': 'Certificate of Signer',
  '04000120': 'Signature',
  '04000305': 'Certified Timestamp Type',
  '04000310': 'Certified Timestamp',
  '04000401': 'Digital Signature Purpose Code Sequence',
  '04000402': 'Referenced Digital Signature Sequence',
  '04000403': 'Referenced SOP Instance MAC Sequence',
  '04000404': 'MAC',
  '04000500': 'Encrypted Attributes Sequence',
  '04000510': 'Encrypted Content Transfer Syntax UID',
  '04000520': 'Encrypted Content',
  '04000550': 'Modified Attributes Sequence',
  '04000561': 'Original Attributes Sequence',
  '04000562': 'Attribute Modification DateTime',
  '04000563': 'Modifying System',
  '04000564': 'Source of Previous Values',
  '04000565': 'Reason for the Attribute Modification',
  '1000xxx0': 'Escape Triplet',
  '1000xxx1': 'Run Length Triplet',
  '1000xxx2': 'Huffman Table Size',
  '1000xxx3': 'Huffman Table Triplet',
  '1000xxx4': 'Shift Table Size',
  '1000xxx5': 'Shift Table Triplet',
  '1010xxxx': 'Zonal Map',
  '20000010': 'Number of Copies',
  '2000001E': 'Printer Configuration Sequence',
  '20000020': 'Print Priority',
  '20000030': 'Medium Type',
  '20000040': 'Film Destination',
  '20000050': 'Film Session Label',
  '20000060': 'Memory Allocation',
  '20000061': 'Maximum Memory Allocation',
  '20000062': 'Color Image Printing Flag',
  '20000063': 'Collation Flag',
  '20000065': 'Annotation Flag',
  '20000067': 'Image Overlay Flag',
  '20000069': 'Presentation LUT Flag',
  '2000006A': 'Image Box Presentation LUT Flag',
  '200000A0': 'Memory Bit Depth',
  '200000A1': 'Printing Bit Depth',
  '200000A2': 'Media Installed Sequence',
  '200000A4': 'Other Media Available Sequence',
  '200000A8': 'Supported Image Display Formats Sequence',
  '20000500': 'Referenced Film Box Sequence',
  '20000510': 'Referenced Stored Print Sequence',
  '20100010': 'Image Display Format',
  '20100030': 'Annotation Display Format ID',
  '20100040': 'Film Orientation',
  '20100050': 'Film Size ID',
  '20100052': 'Printer Resolution ID',
  '20100054': 'Default Printer Resolution ID',
  '20100060': 'Magnification Type',
  '20100080': 'Smoothing Type',
  '201000A6': 'Default Magnification Type',
  '201000A7': 'Other Magnification Types Available',
  '201000A8': 'Default Smoothing Type',
  '201000A9': 'Other Smoothing Types Available',
  '20100100': 'Border Density',
  '20100110': 'Empty Image Density',
  '20100120': 'Min Density',
  '20100130': 'Max Density',
  '20100140': 'Trim',
  '20100150': 'Configuration Information',
  '20100152': 'Configuration Information Description',
  '20100154': 'Maximum Collated Films',
  '2010015E': 'Illumination',
  '20100160': 'Reflected Ambient Light',
  '20100376': 'Printer Pixel Spacing',
  '20100500': 'Referenced Film Session Sequence',
  '20100510': 'Referenced Image Box Sequence',
  '20100520': 'Referenced Basic Annotation Box Sequence',
  '20200010': 'Image Box Position',
  '20200020': 'Polarity',
  '20200030': 'Requested Image Size',
  '20200040': 'Requested Decimate/Crop Behavior',
  '20200050': 'Requested Resolution ID',
  '202000A0': 'Requested Image Size Flag',
  '202000A2': 'Decimate/Crop Result',
  '20200110': 'Basic Grayscale Image Sequence',
  '20200111': 'Basic Color Image Sequence',
  '20200130': 'Referenced Image Overlay Box Sequence',
  '20200140': 'Referenced VOI LUT Box Sequence',
  '20300010': 'Annotation Position',
  '20300020': 'Text String',
  '20400010': 'Referenced Overlay Plane Sequence',
  '20400011': 'Referenced Overlay Plane Groups',
  '20400020': 'Overlay Pixel Data Sequence',
  '20400060': 'Overlay Magnification Type',
  '20400070': 'Overlay Smoothing Type',
  '20400072': 'Overlay or Image Magnification',
  '20400074': 'Magnify to Number of Columns',
  '20400080': 'Overlay Foreground Density',
  '20400082': 'Overlay Background Density',
  '20400090': 'Overlay Mode',
  '20400100': 'Threshold Density',
  '20400500': 'Referenced Image Box Sequence (Retired)',
  '20500010': 'Presentation LUT Sequence',
  '20500020': 'Presentation LUT Shape',
  '20500500': 'Referenced Presentation LUT Sequence',
  '21000010': 'Print Job ID',
  '21000020': 'Execution Status',
  '21000030': 'Execution Status Info',
  '21000040': 'Creation Date',
  '21000050': 'Creation Time',
  '21000070': 'Originator',
  '21000140': 'Destination AE',
  '21000160': 'Owner ID',
  '21000170': 'Number of Films',
  '21000500': 'Referenced Print Job Sequence (Pull Stored Print)',
  '21100010': 'Printer Status',
  '21100020': 'Printer Status Info',
  '21100030': 'Printer Name',
  '21100099': 'Print Queue ID',
  '21200010': 'Queue Status',
  '21200050': 'Print Job Description Sequence',
  '21200070': 'Referenced Print Job Sequence',
  '21300010': 'Print Management Capabilities Sequence',
  '21300015': 'Printer Characteristics Sequence',
  '21300030': 'Film Box Content Sequence',
  '21300040': 'Image Box Content Sequence',
  '21300050': 'Annotation Content Sequence',
  '21300060': 'Image Overlay Box Content Sequence',
  '21300080': 'Presentation LUT Content Sequence',
  '213000A0': 'Proposed Study Sequence',
  '213000C0': 'Original Image Sequence',
  '22000001': 'Label Using Information Extracted From Instances',
  '22000002': 'Label Text',
  '22000003': 'Label Style Selection',
  '22000004': 'Media Disposition',
  '22000005': 'Barcode Value',
  '22000006': 'Barcode Symbology',
  '22000007': 'Allow Media Splitting',
  '22000008': 'Include Non-DICOM Objects',
  '22000009': 'Include Display Application',
  '2200000A': 'Preserve Composite Instances After Media Creation',
  '2200000B': 'Total Number of Pieces of Media Created',
  '2200000C': 'Requested Media Application Profile',
  '2200000D': 'Referenced Storage Media Sequence',
  '2200000E': 'Failure Attributes',
  '2200000F': 'Allow Lossy Compression',
  '22000020': 'Request Priority',
  '30020002': 'RT Image Label',
  '30020003': 'RT Image Name',
  '30020004': 'RT Image Description',
  '3002000A': 'Reported Values Origin',
  '3002000C': 'RT Image Plane',
  '3002000D': 'X-Ray Image Receptor Translation',
  '3002000E': 'X-Ray Image Receptor Angle',
  '30020010': 'RT Image Orientation',
  '30020011': 'Image Plane Pixel Spacing',
  '30020012': 'RT Image Position',
  '30020020': 'Radiation Machine Name',
  '30020022': 'Radiation Machine SAD',
  '30020024': 'Radiation Machine SSD',
  '30020026': 'RT Image SID',
  '30020028': 'Source to Reference Object Distance',
  '30020029': 'Fraction Number',
  '30020030': 'Exposure Sequence',
  '30020032': 'Meterset Exposure',
  '30020034': 'Diaphragm Position',
  '30020040': 'Fluence Map Sequence',
  '30020041': 'Fluence Data Source',
  '30020042': 'Fluence Data Scale',
  '30020050': 'Primary Fluence Mode Sequence',
  '30020051': 'Fluence Mode',
  '30020052': 'Fluence Mode ID',
  '30040001': 'DVH Type',
  '30040002': 'Dose Units',
  '30040004': 'Dose Type',
  '30040005': 'Spatial Transform of Dose',
  '30040006': 'Dose Comment',
  '30040008': 'Normalization Point',
  '3004000A': 'Dose Summation Type',
  '3004000C': 'Grid Frame Offset Vector',
  '3004000E': 'Dose Grid Scaling',
  '30040010': 'RT Dose ROI Sequence',
  '30040012': 'Dose Value',
  '30040014': 'Tissue Heterogeneity Correction',
  '30040040': 'DVH Normalization Point',
  '30040042': 'DVH Normalization Dose Value',
  '30040050': 'DVH Sequence',
  '30040052': 'DVH Dose Scaling',
  '30040054': 'DVH Volume Units',
  '30040056': 'DVH Number of Bins',
  '30040058': 'DVH Data',
  '30040060': 'DVH Referenced ROI Sequence',
  '30040062': 'DVH ROI Contribution Type',
  '30040070': 'DVH Minimum Dose',
  '30040072': 'DVH Maximum Dose',
  '30040074': 'DVH Mean Dose',
  '30060002': 'Structure Set Label',
  '30060004': 'Structure Set Name',
  '30060006': 'Structure Set Description',
  '30060008': 'Structure Set Date',
  '30060009': 'Structure Set Time',
  '30060010': 'Referenced Frame of Reference Sequence',
  '30060012': 'RT Referenced Study Sequence',
  '30060014': 'RT Referenced Series Sequence',
  '30060016': 'Contour Image Sequence',
  '30060018': 'Predecessor Structure Set Sequence',
  '30060020': 'Structure Set ROI Sequence',
  '30060022': 'ROI Number',
  '30060024': 'Referenced Frame of Reference UID',
  '30060026': 'ROI Name',
  '30060028': 'ROI Description',
  '3006002A': 'ROI Display Color',
  '3006002C': 'ROI Volume',
  '30060030': 'RT Related ROI Sequence',
  '30060033': 'RT ROI Relationship',
  '30060036': 'ROI Generation Algorithm',
  '30060038': 'ROI Generation Description',
  '30060039': 'ROI Contour Sequence',
  '30060040': 'Contour Sequence',
  '30060042': 'Contour Geometric Type',
  '30060044': 'Contour Slab Thickness',
  '30060045': 'Contour Offset Vector',
  '30060046': 'Number of Contour Points',
  '30060048': 'Contour Number',
  '30060049': 'Attached Contours',
  '30060050': 'Contour Data',
  '30060080': 'RT ROI Observations Sequence',
  '30060082': 'Observation Number',
  '30060084': 'Referenced ROI Number',
  '30060085': 'ROI Observation Label',
  '30060086': 'RT ROI Identification Code Sequence',
  '30060088': 'ROI Observation Description',
  '300600A0': 'Related RT ROI Observations Sequence',
  '300600A4': 'RT ROI Interpreted Type',
  '300600A6': 'ROI Interpreter',
  '300600B0': 'ROI Physical Properties Sequence',
  '300600B2': 'ROI Physical Property',
  '300600B4': 'ROI Physical Property Value',
  '300600B6': 'ROI Elemental Composition Sequence',
  '300600B7': 'ROI Elemental Composition Atomic Number',
  '300600B8': 'ROI Elemental Composition Atomic Mass Fraction',
  '300600C0': 'Frame of Reference Relationship Sequence',
  '300600C2': 'Related Frame of Reference UID',
  '300600C4': 'Frame of Reference Transformation Type',
  '300600C6': 'Frame of Reference Transformation Matrix',
  '300600C8': 'Frame of Reference Transformation Comment',
  '30080010': 'Measured Dose Reference Sequence',
  '30080012': 'Measured Dose Description',
  '30080014': 'Measured Dose Type',
  '30080016': 'Measured Dose Value',
  '30080020': 'Treatment Session Beam Sequence',
  '30080021': 'Treatment Session Ion Beam Sequence',
  '30080022': 'Current Fraction Number',
  '30080024': 'Treatment Control Point Date',
  '30080025': 'Treatment Control Point Time',
  '3008002A': 'Treatment Termination Status',
  '3008002B': 'Treatment Termination Code',
  '3008002C': 'Treatment Verification Status',
  '30080030': 'Referenced Treatment Record Sequence',
  '30080032': 'Specified Primary Meterset',
  '30080033': 'Specified Secondary Meterset',
  '30080036': 'Delivered Primary Meterset',
  '30080037': 'Delivered Secondary Meterset',
  '3008003A': 'Specified Treatment Time',
  '3008003B': 'Delivered Treatment Time',
  '30080040': 'Control Point Delivery Sequence',
  '30080041': 'Ion Control Point Delivery Sequence',
  '30080042': 'Specified Meterset',
  '30080044': 'Delivered Meterset',
  '30080045': 'Meterset Rate Set',
  '30080046': 'Meterset Rate Delivered',
  '30080047': 'Scan Spot Metersets Delivered',
  '30080048': 'Dose Rate Delivered',
  '30080050': 'Treatment Summary Calculated Dose Reference Sequence',
  '30080052': 'Cumulative Dose to Dose Reference',
  '30080054': 'First Treatment Date',
  '30080056': 'Most Recent Treatment Date',
  '3008005A': 'Number of Fractions Delivered',
  '30080060': 'Override Sequence',
  '30080061': 'Parameter Sequence Pointer',
  '30080062': 'Override Parameter Pointer',
  '30080063': 'Parameter Item Index',
  '30080064': 'Measured Dose Reference Number',
  '30080065': 'Parameter Pointer',
  '30080066': 'Override Reason',
  '30080068': 'Corrected Parameter Sequence',
  '3008006A': 'Correction Value',
  '30080070': 'Calculated Dose Reference Sequence',
  '30080072': 'Calculated Dose Reference Number',
  '30080074': 'Calculated Dose Reference Description',
  '30080076': 'Calculated Dose Reference Dose Value',
  '30080078': 'Start Meterset',
  '3008007A': 'End Meterset',
  '30080080': 'Referenced Measured Dose Reference Sequence',
  '30080082': 'Referenced Measured Dose Reference Number',
  '30080090': 'Referenced Calculated Dose Reference Sequence',
  '30080092': 'Referenced Calculated Dose Reference Number',
  '300800A0': 'Beam Limiting Device Leaf Pairs Sequence',
  '300800B0': 'Recorded Wedge Sequence',
  '300800C0': 'Recorded Compensator Sequence',
  '300800D0': 'Recorded Block Sequence',
  '300800E0': 'Treatment Summary Measured Dose Reference Sequence',
  '300800F0': 'Recorded Snout Sequence',
  '300800F2': 'Recorded Range Shifter Sequence',
  '300800F4': 'Recorded Lateral Spreading Device Sequence',
  '300800F6': 'Recorded Range Modulator Sequence',
  '30080100': 'Recorded Source Sequence',
  '30080105': 'Source Serial Number',
  '30080110': 'Treatment Session Application Setup Sequence',
  '30080116': 'Application Setup Check',
  '30080120': 'Recorded Brachy Accessory Device Sequence',
  '30080122': 'Referenced Brachy Accessory Device Number',
  '30080130': 'Recorded Channel Sequence',
  '30080132': 'Specified Channel Total Time',
  '30080134': 'Delivered Channel Total Time',
  '30080136': 'Specified Number of Pulses',
  '30080138': 'Delivered Number of Pulses',
  '3008013A': 'Specified Pulse Repetition Interval',
  '3008013C': 'Delivered Pulse Repetition Interval',
  '30080140': 'Recorded Source Applicator Sequence',
  '30080142': 'Referenced Source Applicator Number',
  '30080150': 'Recorded Channel Shield Sequence',
  '30080152': 'Referenced Channel Shield Number',
  '30080160': 'Brachy Control Point Delivered Sequence',
  '30080162': 'Safe Position Exit Date',
  '30080164': 'Safe Position Exit Time',
  '30080166': 'Safe Position Return Date',
  '30080168': 'Safe Position Return Time',
  '30080200': 'Current Treatment Status',
  '30080202': 'Treatment Status Comment',
  '30080220': 'Fraction Group Summary Sequence',
  '30080223': 'Referenced Fraction Number',
  '30080224': 'Fraction Group Type',
  '30080230': 'Beam Stopper Position',
  '30080240': 'Fraction Status Summary Sequence',
  '30080250': 'Treatment Date',
  '30080251': 'Treatment Time',
  '300A0002': 'RT Plan Label',
  '300A0003': 'RT Plan Name',
  '300A0004': 'RT Plan Description',
  '300A0006': 'RT Plan Date',
  '300A0007': 'RT Plan Time',
  '300A0009': 'Treatment Protocols',
  '300A000A': 'Plan Intent',
  '300A000B': 'Treatment Sites',
  '300A000C': 'RT Plan Geometry',
  '300A000E': 'Prescription Description',
  '300A0010': 'Dose Reference Sequence',
  '300A0012': 'Dose Reference Number',
  '300A0013': 'Dose Reference UID',
  '300A0014': 'Dose Reference Structure Type',
  '300A0015': 'Nominal Beam Energy Unit',
  '300A0016': 'Dose Reference Description',
  '300A0018': 'Dose Reference Point Coordinates',
  '300A001A': 'Nominal Prior Dose',
  '300A0020': 'Dose Reference Type',
  '300A0021': 'Constraint Weight',
  '300A0022': 'Delivery Warning Dose',
  '300A0023': 'Delivery Maximum Dose',
  '300A0025': 'Target Minimum Dose',
  '300A0026': 'Target Prescription Dose',
  '300A0027': 'Target Maximum Dose',
  '300A0028': 'Target Underdose Volume Fraction',
  '300A002A': 'Organ at Risk Full-volume Dose',
  '300A002B': 'Organ at Risk Limit Dose',
  '300A002C': 'Organ at Risk Maximum Dose',
  '300A002D': 'Organ at Risk Overdose Volume Fraction',
  '300A0040': 'Tolerance Table Sequence',
  '300A0042': 'Tolerance Table Number',
  '300A0043': 'Tolerance Table Label',
  '300A0044': 'Gantry Angle Tolerance',
  '300A0046': 'Beam Limiting Device Angle Tolerance',
  '300A0048': 'Beam Limiting Device Tolerance Sequence',
  '300A004A': 'Beam Limiting Device Position Tolerance',
  '300A004B': 'Snout Position Tolerance',
  '300A004C': 'Patient Support Angle Tolerance',
  '300A004E': 'Table Top Eccentric Angle Tolerance',
  '300A004F': 'Table Top Pitch Angle Tolerance',
  '300A0050': 'Table Top Roll Angle Tolerance',
  '300A0051': 'Table Top Vertical Position Tolerance',
  '300A0052': 'Table Top Longitudinal Position Tolerance',
  '300A0053': 'Table Top Lateral Position Tolerance',
  '300A0055': 'RT Plan Relationship',
  '300A0070': 'Fraction Group Sequence',
  '300A0071': 'Fraction Group Number',
  '300A0072': 'Fraction Group Description',
  '300A0078': 'Number of Fractions Planned',
  '300A0079': 'Number of Fraction Pattern Digits Per Day',
  '300A007A': 'Repeat Fraction Cycle Length',
  '300A007B': 'Fraction Pattern',
  '300A0080': 'Number of Beams',
  '300A0082': 'Beam Dose Specification Point',
  '300A0084': 'Beam Dose',
  '300A0086': 'Beam Meterset',
  '300A0088': 'Beam Dose Point Depth',
  '300A0089': 'Beam Dose Point Equivalent Depth',
  '300A008A': 'Beam Dose Point SSD',
  '300A008B': 'Beam Dose Meaning',
  '300A008C': 'Beam Dose Verification Control Point Sequence',
  '300A008D': 'Average Beam Dose Point Depth',
  '300A008E': 'Average Beam Dose Point Equivalent Depth',
  '300A008F': 'Average Beam Dose Point SSD',
  '300A00A0': 'Number of Brachy Application Setups',
  '300A00A2': 'Brachy Application Setup Dose Specification Point',
  '300A00A4': 'Brachy Application Setup Dose',
  '300A00B0': 'Beam Sequence',
  '300A00B2': 'Treatment Machine Name',
  '300A00B3': 'Primary Dosimeter Unit',
  '300A00B4': 'Source-Axis Distance',
  '300A00B6': 'Beam Limiting Device Sequence',
  '300A00B8': 'RT Beam Limiting Device Type',
  '300A00BA': 'Source to Beam Limiting Device Distance',
  '300A00BB': 'Isocenter to Beam Limiting Device Distance',
  '300A00BC': 'Number of Leaf/Jaw Pairs',
  '300A00BE': 'Leaf Position Boundaries',
  '300A00C0': 'Beam Number',
  '300A00C2': 'Beam Name',
  '300A00C3': 'Beam Description',
  '300A00C4': 'Beam Type',
  '300A00C6': 'Radiation Type',
  '300A00C7': 'High-Dose Technique Type',
  '300A00C8': 'Reference Image Number',
  '300A00CA': 'Planned Verification Image Sequence',
  '300A00CC': 'Imaging Device-Specific Acquisition Parameters',
  '300A00CE': 'Treatment Delivery Type',
  '300A00D0': 'Number of Wedges',
  '300A00D1': 'Wedge Sequence',
  '300A00D2': 'Wedge Number',
  '300A00D3': 'Wedge Type',
  '300A00D4': 'Wedge ID',
  '300A00D5': 'Wedge Angle',
  '300A00D6': 'Wedge Factor',
  '300A00D7': 'Total Wedge Tray Water-Equivalent Thickness',
  '300A00D8': 'Wedge Orientation',
  '300A00D9': 'Isocenter to Wedge Tray Distance',
  '300A00DA': 'Source to Wedge Tray Distance',
  '300A00DB': 'Wedge Thin Edge Position',
  '300A00DC': 'Bolus ID',
  '300A00DD': 'Bolus Description',
  '300A00E0': 'Number of Compensators',
  '300A00E1': 'Material ID',
  '300A00E2': 'Total Compensator Tray Factor',
  '300A00E3': 'Compensator Sequence',
  '300A00E4': 'Compensator Number',
  '300A00E5': 'Compensator ID',
  '300A00E6': 'Source to Compensator Tray Distance',
  '300A00E7': 'Compensator Rows',
  '300A00E8': 'Compensator Columns',
  '300A00E9': 'Compensator Pixel Spacing',
  '300A00EA': 'Compensator Position',
  '300A00EB': 'Compensator Transmission Data',
  '300A00EC': 'Compensator Thickness Data',
  '300A00ED': 'Number of Boli',
  '300A00EE': 'Compensator Type',
  '300A00EF': 'Compensator Tray ID',
  '300A00F0': 'Number of Blocks',
  '300A00F2': 'Total Block Tray Factor',
  '300A00F3': 'Total Block Tray Water-Equivalent Thickness',
  '300A00F4': 'Block Sequence',
  '300A00F5': 'Block Tray ID',
  '300A00F6': 'Source to Block Tray Distance',
  '300A00F7': 'Isocenter to Block Tray Distance',
  '300A00F8': 'Block Type',
  '300A00F9': 'Accessory Code',
  '300A00FA': 'Block Divergence',
  '300A00FB': 'Block Mounting Position',
  '300A00FC': 'Block Number',
  '300A00FE': 'Block Name',
  '300A0100': 'Block Thickness',
  '300A0102': 'Block Transmission',
  '300A0104': 'Block Number of Points',
  '300A0106': 'Block Data',
  '300A0107': 'Applicator Sequence',
  '300A0108': 'Applicator ID',
  '300A0109': 'Applicator Type',
  '300A010A': 'Applicator Description',
  '300A010C': 'Cumulative Dose Reference Coefficient',
  '300A010E': 'Final Cumulative Meterset Weight',
  '300A0110': 'Number of Control Points',
  '300A0111': 'Control Point Sequence',
  '300A0112': 'Control Point Index',
  '300A0114': 'Nominal Beam Energy',
  '300A0115': 'Dose Rate Set',
  '300A0116': 'Wedge Position Sequence',
  '300A0118': 'Wedge Position',
  '300A011A': 'Beam Limiting Device Position Sequence',
  '300A011C': 'Leaf/Jaw Positions',
  '300A011E': 'Gantry Angle',
  '300A011F': 'Gantry Rotation Direction',
  '300A0120': 'Beam Limiting Device Angle',
  '300A0121': 'Beam Limiting Device Rotation Direction',
  '300A0122': 'Patient Support Angle',
  '300A0123': 'Patient Support Rotation Direction',
  '300A0124': 'Table Top Eccentric Axis Distance',
  '300A0125': 'Table Top Eccentric Angle',
  '300A0126': 'Table Top Eccentric Rotation Direction',
  '300A0128': 'Table Top Vertical Position',
  '300A0129': 'Table Top Longitudinal Position',
  '300A012A': 'Table Top Lateral Position',
  '300A012C': 'Isocenter Position',
  '300A012E': 'Surface Entry Point',
  '300A0130': 'Source to Surface Distance',
  '300A0134': 'Cumulative Meterset Weight',
  '300A0140': 'Table Top Pitch Angle',
  '300A0142': 'Table Top Pitch Rotation Direction',
  '300A0144': 'Table Top Roll Angle',
  '300A0146': 'Table Top Roll Rotation Direction',
  '300A0148': 'Head Fixation Angle',
  '300A014A': 'Gantry Pitch Angle',
  '300A014C': 'Gantry Pitch Rotation Direction',
  '300A014E': 'Gantry Pitch Angle Tolerance',
  '300A0180': 'Patient Setup Sequence',
  '300A0182': 'Patient Setup Number',
  '300A0183': 'Patient Setup Label',
  '300A0184': 'Patient Additional Position',
  '300A0190': 'Fixation Device Sequence',
  '300A0192': 'Fixation Device Type',
  '300A0194': 'Fixation Device Label',
  '300A0196': 'Fixation Device Description',
  '300A0198': 'Fixation Device Position',
  '300A0199': 'Fixation Device Pitch Angle',
  '300A019A': 'Fixation Device Roll Angle',
  '300A01A0': 'Shielding Device Sequence',
  '300A01A2': 'Shielding Device Type',
  '300A01A4': 'Shielding Device Label',
  '300A01A6': 'Shielding Device Description',
  '300A01A8': 'Shielding Device Position',
  '300A01B0': 'Setup Technique',
  '300A01B2': 'Setup Technique Description',
  '300A01B4': 'Setup Device Sequence',
  '300A01B6': 'Setup Device Type',
  '300A01B8': 'Setup Device Label',
  '300A01BA': 'Setup Device Description',
  '300A01BC': 'Setup Device Parameter',
  '300A01D0': 'Setup Reference Description',
  '300A01D2': 'Table Top Vertical Setup Displacement',
  '300A01D4': 'Table Top Longitudinal Setup Displacement',
  '300A01D6': 'Table Top Lateral Setup Displacement',
  '300A0200': 'Brachy Treatment Technique',
  '300A0202': 'Brachy Treatment Type',
  '300A0206': 'Treatment Machine Sequence',
  '300A0210': 'Source Sequence',
  '300A0212': 'Source Number',
  '300A0214': 'Source Type',
  '300A0216': 'Source Manufacturer',
  '300A0218': 'Active Source Diameter',
  '300A021A': 'Active Source Length',
  '300A021B': 'Source Model ID',
  '300A021C': 'Source Description',
  '300A0222': 'Source Encapsulation Nominal Thickness',
  '300A0224': 'Source Encapsulation Nominal Transmission',
  '300A0226': 'Source Isotope Name',
  '300A0228': 'Source Isotope Half Life',
  '300A0229': 'Source Strength Units',
  '300A022A': 'Reference Air Kerma Rate',
  '300A022B': 'Source Strength',
  '300A022C': 'Source Strength Reference Date',
  '300A022E': 'Source Strength Reference Time',
  '300A0230': 'Application Setup Sequence',
  '300A0232': 'Application Setup Type',
  '300A0234': 'Application Setup Number',
  '300A0236': 'Application Setup Name',
  '300A0238': 'Application Setup Manufacturer',
  '300A0240': 'Template Number',
  '300A0242': 'Template Type',
  '300A0244': 'Template Name',
  '300A0250': 'Total Reference Air Kerma',
  '300A0260': 'Brachy Accessory Device Sequence',
  '300A0262': 'Brachy Accessory Device Number',
  '300A0263': 'Brachy Accessory Device ID',
  '300A0264': 'Brachy Accessory Device Type',
  '300A0266': 'Brachy Accessory Device Name',
  '300A026A': 'Brachy Accessory Device Nominal Thickness',
  '300A026C': 'Brachy Accessory Device Nominal Transmission',
  '300A0280': 'Channel Sequence',
  '300A0282': 'Channel Number',
  '300A0284': 'Channel Length',
  '300A0286': 'Channel Total Time',
  '300A0288': 'Source Movement Type',
  '300A028A': 'Number of Pulses',
  '300A028C': 'Pulse Repetition Interval',
  '300A0290': 'Source Applicator Number',
  '300A0291': 'Source Applicator ID',
  '300A0292': 'Source Applicator Type',
  '300A0294': 'Source Applicator Name',
  '300A0296': 'Source Applicator Length',
  '300A0298': 'Source Applicator Manufacturer',
  '300A029C': 'Source Applicator Wall Nominal Thickness',
  '300A029E': 'Source Applicator Wall Nominal Transmission',
  '300A02A0': 'Source Applicator Step Size',
  '300A02A2': 'Transfer Tube Number',
  '300A02A4': 'Transfer Tube Length',
  '300A02B0': 'Channel Shield Sequence',
  '300A02B2': 'Channel Shield Number',
  '300A02B3': 'Channel Shield ID',
  '300A02B4': 'Channel Shield Name',
  '300A02B8': 'Channel Shield Nominal Thickness',
  '300A02BA': 'Channel Shield Nominal Transmission',
  '300A02C8': 'Final Cumulative Time Weight',
  '300A02D0': 'Brachy Control Point Sequence',
  '300A02D2': 'Control Point Relative Position',
  '300A02D4': 'Control Point 3D Position',
  '300A02D6': 'Cumulative Time Weight',
  '300A02E0': 'Compensator Divergence',
  '300A02E1': 'Compensator Mounting Position',
  '300A02E2': 'Source to Compensator Distance',
  '300A02E3': 'Total Compensator Tray Water-Equivalent Thickness',
  '300A02E4': 'Isocenter to Compensator Tray Distance',
  '300A02E5': 'Compensator Column Offset',
  '300A02E6': 'Isocenter to Compensator Distances',
  '300A02E7': 'Compensator Relative Stopping Power Ratio',
  '300A02E8': 'Compensator Milling Tool Diameter',
  '300A02EA': 'Ion Range Compensator Sequence',
  '300A02EB': 'Compensator Description',
  '300A0302': 'Radiation Mass Number',
  '300A0304': 'Radiation Atomic Number',
  '300A0306': 'Radiation Charge State',
  '300A0308': 'Scan Mode',
  '300A030A': 'Virtual Source-Axis Distances',
  '300A030C': 'Snout Sequence',
  '300A030D': 'Snout Position',
  '300A030F': 'Snout ID',
  '300A0312': 'Number of Range Shifters',
  '300A0314': 'Range Shifter Sequence',
  '300A0316': 'Range Shifter Number',
  '300A0318': 'Range Shifter ID',
  '300A0320': 'Range Shifter Type',
  '300A0322': 'Range Shifter Description',
  '300A0330': 'Number of Lateral Spreading Devices',
  '300A0332': 'Lateral Spreading Device Sequence',
  '300A0334': 'Lateral Spreading Device Number',
  '300A0336': 'Lateral Spreading Device ID',
  '300A0338': 'Lateral Spreading Device Type',
  '300A033A': 'Lateral Spreading Device Description',
  '300A033C': 'Lateral Spreading Device Water Equivalent Thickness',
  '300A0340': 'Number of Range Modulators',
  '300A0342': 'Range Modulator Sequence',
  '300A0344': 'Range Modulator Number',
  '300A0346': 'Range Modulator ID',
  '300A0348': 'Range Modulator Type',
  '300A034A': 'Range Modulator Description',
  '300A034C': 'Beam Current Modulation ID',
  '300A0350': 'Patient Support Type',
  '300A0352': 'Patient Support ID',
  '300A0354': 'Patient Support Accessory Code',
  '300A0356': 'Fixation Light Azimuthal Angle',
  '300A0358': 'Fixation Light Polar Angle',
  '300A035A': 'Meterset Rate',
  '300A0360': 'Range Shifter Settings Sequence',
  '300A0362': 'Range Shifter Setting',
  '300A0364': 'Isocenter to Range Shifter Distance',
  '300A0366': 'Range Shifter Water Equivalent Thickness',
  '300A0370': 'Lateral Spreading Device Settings Sequence',
  '300A0372': 'Lateral Spreading Device Setting',
  '300A0374': 'Isocenter to Lateral Spreading Device Distance',
  '300A0380': 'Range Modulator Settings Sequence',
  '300A0382': 'Range Modulator Gating Start Value',
  '300A0384': 'Range Modulator Gating Stop Value',
  '300A0386': 'Range Modulator Gating Start Water Equivalent Thickness',
  '300A0388': 'Range Modulator Gating Stop Water Equivalent Thickness',
  '300A038A': 'Isocenter to Range Modulator Distance',
  '300A0390': 'Scan Spot Tune ID',
  '300A0392': 'Number of Scan Spot Positions',
  '300A0394': 'Scan Spot Position Map',
  '300A0396': 'Scan Spot Meterset Weights',
  '300A0398': 'Scanning Spot Size',
  '300A039A': 'Number of Paintings',
  '300A03A0': 'Ion Tolerance Table Sequence',
  '300A03A2': 'Ion Beam Sequence',
  '300A03A4': 'Ion Beam Limiting Device Sequence',
  '300A03A6': 'Ion Block Sequence',
  '300A03A8': 'Ion Control Point Sequence',
  '300A03AA': 'Ion Wedge Sequence',
  '300A03AC': 'Ion Wedge Position Sequence',
  '300A0401': 'Referenced Setup Image Sequence',
  '300A0402': 'Setup Image Comment',
  '300A0410': 'Motion Synchronization Sequence',
  '300A0412': 'Control Point Orientation',
  '300A0420': 'General Accessory Sequence',
  '300A0421': 'General Accessory ID',
  '300A0422': 'General Accessory Description',
  '300A0423': 'General Accessory Type',
  '300A0424': 'General Accessory Number',
  '300A0425': 'Source to General Accessory Distance',
  '300A0431': 'Applicator Geometry Sequence',
  '300A0432': 'Applicator Aperture Shape',
  '300A0433': 'Applicator Opening',
  '300A0434': 'Applicator Opening X',
  '300A0435': 'Applicator Opening Y',
  '300A0436': 'Source to Applicator Mounting Position Distance',
  '300C0002': 'Referenced RT Plan Sequence',
  '300C0004': 'Referenced Beam Sequence',
  '300C0006': 'Referenced Beam Number',
  '300C0007': 'Referenced Reference Image Number',
  '300C0008': 'Start Cumulative Meterset Weight',
  '300C0009': 'End Cumulative Meterset Weight',
  '300C000A': 'Referenced Brachy Application Setup Sequence',
  '300C000C': 'Referenced Brachy Application Setup Number',
  '300C000E': 'Referenced Source Number',
  '300C0020': 'Referenced Fraction Group Sequence',
  '300C0022': 'Referenced Fraction Group Number',
  '300C0040': 'Referenced Verification Image Sequence',
  '300C0042': 'Referenced Reference Image Sequence',
  '300C0050': 'Referenced Dose Reference Sequence',
  '300C0051': 'Referenced Dose Reference Number',
  '300C0055': 'Brachy Referenced Dose Reference Sequence',
  '300C0060': 'Referenced Structure Set Sequence',
  '300C006A': 'Referenced Patient Setup Number',
  '300C0080': 'Referenced Dose Sequence',
  '300C00A0': 'Referenced Tolerance Table Number',
  '300C00B0': 'Referenced Bolus Sequence',
  '300C00C0': 'Referenced Wedge Number',
  '300C00D0': 'Referenced Compensator Number',
  '300C00E0': 'Referenced Block Number',
  '300C00F0': 'Referenced Control Point Index',
  '300C00F2': 'Referenced Control Point Sequence',
  '300C00F4': 'Referenced Start Control Point Index',
  '300C00F6': 'Referenced Stop Control Point Index',
  '300C0100': 'Referenced Range Shifter Number',
  '300C0102': 'Referenced Lateral Spreading Device Number',
  '300C0104': 'Referenced Range Modulator Number',
  '300E0002': 'Approval Status',
  '300E0004': 'Review Date',
  '300E0005': 'Review Time',
  '300E0008': 'Reviewer Name',
  '40000010': 'Arbitrary',
  '40004000': 'Text Comments',
  '40080040': 'Results ID',
  '40080042': 'Results ID Issuer',
  '40080050': 'Referenced Interpretation Sequence',
  '400800FF': 'Report Production Status (Trial)',
  '40080100': 'Interpretation Recorded Date',
  '40080101': 'Interpretation Recorded Time',
  '40080102': 'Interpretation Recorder',
  '40080103': 'Reference to Recorded Sound',
  '40080108': 'Interpretation Transcription Date',
  '40080109': 'Interpretation Transcription Time',
  '4008010A': 'Interpretation Transcriber',
  '4008010B': 'Interpretation Text',
  '4008010C': 'Interpretation Author',
  '40080111': 'Interpretation Approver Sequence',
  '40080112': 'Interpretation Approval Date',
  '40080113': 'Interpretation Approval Time',
  '40080114': 'Physician Approving Interpretation',
  '40080115': 'Interpretation Diagnosis Description',
  '40080117': 'Interpretation Diagnosis Code Sequence',
  '40080118': 'Results Distribution List Sequence',
  '40080119': 'Distribution Name',
  '4008011A': 'Distribution Address',
  '40080200': 'Interpretation ID',
  '40080202': 'Interpretation ID Issuer',
  '40080210': 'Interpretation Type ID',
  '40080212': 'Interpretation Status ID',
  '40080300': 'Impressions',
  '40084000': 'Results Comments',
  '40100001': 'Low Energy Detectors',
  '40100002': 'High Energy Detectors',
  '40100004': 'Detector Geometry Sequence',
  '40101001': 'Threat ROI Voxel Sequence',
  '40101004': 'Threat ROI Base',
  '40101005': 'Threat ROI Extents',
  '40101006': 'Threat ROI Bitmap',
  '40101007': 'Route Segment ID',
  '40101008': 'Gantry Type',
  '40101009': 'OOI Owner Type',
  '4010100A': 'Route Segment Sequence',
  '40101010': 'Potential Threat Object ID',
  '40101011': 'Threat Sequence',
  '40101012': 'Threat Category',
  '40101013': 'Threat Category Description',
  '40101014': 'ATD Ability Assessment',
  '40101015': 'ATD Assessment Flag',
  '40101016': 'ATD Assessment Probability',
  '40101017': 'Mass',
  '40101018': 'Density',
  '40101019': 'Z Effective',
  '4010101A': 'Boarding Pass ID',
  '4010101B': 'Center of Mass',
  '4010101C': 'Center of PTO',
  '4010101D': 'Bounding Polygon',
  '4010101E': 'Route Segment Start Location ID',
  '4010101F': 'Route Segment End Location ID',
  '40101020': 'Route Segment Location ID Type',
  '40101021': 'Abort Reason',
  '40101023': 'Volume of PTO',
  '40101024': 'Abort Flag',
  '40101025': 'Route Segment Start Time',
  '40101026': 'Route Segment End Time',
  '40101027': 'TDR Type',
  '40101028': 'International Route Segment',
  '40101029': 'Threat Detection Algorithm and Version',
  '4010102A': 'Assigned Location',
  '4010102B': 'Alarm Decision Time',
  '40101031': 'Alarm Decision',
  '40101033': 'Number of Total Objects',
  '40101034': 'Number of Alarm Objects',
  '40101037': 'PTO Representation Sequence',
  '40101038': 'ATD Assessment Sequence',
  '40101039': 'TIP Type',
  '4010103A': 'DICOS Version',
  '40101041': 'OOI Owner Creation Time',
  '40101042': 'OOI Type',
  '40101043': 'OOI Size',
  '40101044': 'Acquisition Status',
  '40101045': 'Basis Materials Code Sequence',
  '40101046': 'Phantom Type',
  '40101047': 'OOI Owner Sequence',
  '40101048': 'Scan Type',
  '40101051': 'Itinerary ID',
  '40101052': 'Itinerary ID Type',
  '40101053': 'Itinerary ID Assigning Authority',
  '40101054': 'Route ID',
  '40101055': 'Route ID Assigning Authority',
  '40101056': 'Inbound Arrival Type',
  '40101058': 'Carrier ID',
  '40101059': 'Carrier ID Assigning Authority',
  '40101060': 'Source Orientation',
  '40101061': 'Source Position',
  '40101062': 'Belt Height',
  '40101064': 'Algorithm Routing Code Sequence',
  '40101067': 'Transport Classification',
  '40101068': 'OOI Type Descriptor',
  '40101069': 'Total Processing Time',
  '4010106C': 'Detector Calibration Data',
  '4010106D': 'Additional Screening Performed',
  '4010106E': 'Additional Inspection Selection Criteria',
  '4010106F': 'Additional Inspection Method Sequence',
  '40101070': 'AIT Device Type',
  '40101071': 'QR Measurements Sequence',
  '40101072': 'Target Material Sequence',
  '40101073': 'SNR Threshold',
  '40101075': 'Image Scale Representation',
  '40101076': 'Referenced PTO Sequence',
  '40101077': 'Referenced TDR Instance Sequence',
  '40101078': 'PTO Location Description',
  '40101079': 'Anomaly Locator Indicator Sequence',
  '4010107A': 'Anomaly Locator Indicator',
  '4010107B': 'PTO Region Sequence',
  '4010107C': 'Inspection Selection Criteria',
  '4010107D': 'Secondary Inspection Method Sequence',
  '4010107E': 'PRCS to RCS Orientation',
  '4FFE0001': 'MAC Parameters Sequence',
  '50xx0005': 'Curve Dimensions',
  '50xx0010': 'Number of Points',
  '50xx0020': 'Type of Data',
  '50xx0022': 'Curve Description',
  '50xx0030': 'Axis Units',
  '50xx0040': 'Axis Labels',
  '50xx0103': 'Data Value Representation',
  '50xx0104': 'Minimum Coordinate Value',
  '50xx0105': 'Maximum Coordinate Value',
  '50xx0106': 'Curve Range',
  '50xx0110': 'Curve Data Descriptor',
  '50xx0112': 'Coordinate Start Value',
  '50xx0114': 'Coordinate Step Value',
  '50xx1001': 'Curve Activation Layer',
  '50xx2000': 'Audio Type',
  '50xx2002': 'Audio Sample Format',
  '50xx2004': 'Number of Channels',
  '50xx2006': 'Number of Samples',
  '50xx2008': 'Sample Rate',
  '50xx200A': 'Total Time',
  '50xx200C': 'Audio Sample Data',
  '50xx200E': 'Audio Comments',
  '50xx2500': 'Curve Label',
  '50xx2600': 'Curve Referenced Overlay Sequence',
  '50xx2610': 'Curve Referenced Overlay Group',
  '50xx3000': 'Curve Data',
  '52009229': 'Shared Functional Groups Sequence',
  '52009230': 'Per-frame Functional Groups Sequence',
  '54000100': 'Waveform Sequence',
  '54000110': 'Channel Minimum Value',
  '54000112': 'Channel Maximum Value',
  '54001004': 'Waveform Bits Allocated',
  '54001006': 'Waveform Sample Interpretation',
  '5400100A': 'Waveform Padding Value',
  '54001010': 'Waveform Data',
  '56000010': 'First Order Phase Correction Angle',
  '56000020': 'Spectroscopy Data',
  '60xx0010': 'Overlay Rows',
  '60xx0011': 'Overlay Columns',
  '60xx0012': 'Overlay Planes',
  '60xx0015': 'Number of Frames in Overlay',
  '60xx0022': 'Overlay Description',
  '60xx0040': 'Overlay Type',
  '60xx0045': 'Overlay Subtype',
  '60xx0050': 'Overlay Origin',
  '60xx0051': 'Image Frame Origin',
  '60xx0052': 'Overlay Plane Origin',
  '60xx0060': 'Overlay Compression Code',
  '60xx0061': 'Overlay Compression Originator',
  '60xx0062': 'Overlay Compression Label',
  '60xx0063': 'Overlay Compression Description',
  '60xx0066': 'Overlay Compression Step Pointers',
  '60xx0068': 'Overlay Repeat Interval',
  '60xx0069': 'Overlay Bits Grouped',
  '60xx0100': 'Overlay Bits Allocated',
  '60xx0102': 'Overlay Bit Position',
  '60xx0110': 'Overlay Format',
  '60xx0200': 'Overlay Location',
  '60xx0800': 'Overlay Code Label',
  '60xx0802': 'Overlay Number of Tables',
  '60xx0803': 'Overlay Code Table Location',
  '60xx0804': 'Overlay Bits For Code Word',
  '60xx1001': 'Overlay Activation Layer',
  '60xx1100': 'Overlay Descriptor - Gray',
  '60xx1101': 'Overlay Descriptor - Red',
  '60xx1102': 'Overlay Descriptor - Green',
  '60xx1103': 'Overlay Descriptor - Blue',
  '60xx1200': 'Overlays - Gray',
  '60xx1201': 'Overlays - Red',
  '60xx1202': 'Overlays - Green',
  '60xx1203': 'Overlays - Blue',
  '60xx1301': 'ROI Area',
  '60xx1302': 'ROI Mean',
  '60xx1303': 'ROI Standard Deviation',
  '60xx1500': 'Overlay Label',
  '60xx3000': 'Overlay Data',
  '60xx4000': 'Overlay Comments',
  '7FE00010': 'Pixel Data',
  '7FE00020': 'Coefficients SDVN',
  '7FE00030': 'Coefficients SDHN',
  '7FE00040': 'Coefficients SDDN',
  '7Fxx0010': 'Variable Pixel Data',
  '7Fxx0011': 'Variable Next Data Group',
  '7Fxx0020': 'Variable Coefficients SDVN',
  '7Fxx0030': 'Variable Coefficients SDHN',
  '7Fxx0040': 'Variable Coefficients SDDN',
  'FFFAFFFA': 'Digital Signatures Sequence',
  'FFFCFFFC': 'Data Set Trailing Padding',
  'FFFEE000': 'Item',
  'FFFEE00D': 'Item Delimitation Item',
  'FFFEE0DD': 'Sequence Delimitation Item',
  '00020000': 'File Meta Information Group Length',
  '00020001': 'File Meta Information Version',
  '00020002': 'Media Storage SOP Class UID',
  '00020003': 'Media Storage SOP Instance UID',
  '00020010': 'Transfer Syntax UID',
  '00020012': 'Implementation Class UID',
  '00020013': 'Implementation Version Name',
  '00020016': 'Source Application Entity Title',
  '00020100': 'Private Information Creator UID',
  '00020102': 'Private Information',
};
